// InstanceCustomers.js
import { useLocation } from "react-router-dom";

import { useFormikContext } from "formik";
import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from "react";
import {
  Button,
  TextField,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Box,
  Checkbox,
  Grid,
  Paper,
  Tabs,
  Tab,
  ListItemText,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Avatar,
  FormLabel,
  FormHelperText,
  ToggleButton,
  ToggleButtonGroup,
  Alert,
  TablePagination,
  Stack,
  Chip,
  Divider,
  InputAdornment,
  Skeleton,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Menu,
  ListItemIcon,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import HistoryIcon from "@mui/icons-material/History";
import ImageIcon from "@mui/icons-material/Image"; // Fallback icon
import WhatshotIcon from "@mui/icons-material/Whatshot";
import GroupIcon from "@mui/icons-material/Group";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import PeopleIcon from "@mui/icons-material/People";
import OutlinedInput from "@mui/material/OutlinedInput";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import HourglassFullIcon from "@mui/icons-material/HourglassFull"; // in-review icon
import PersonIcon from "@mui/icons-material/Person";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { getTerms } from "../../../../services/terms";
import { fetchInstanceDefaultsByUniqueId } from "../../../../services/operationsManagement";
import { getAllClientAccounts } from "../../../../services/shipping";
import ThirdPartyShippingAccount from "../../../../components/Shipping/ThirdPartyShippingAccount";
import { getTaxes } from "../../../../services/tax";
import { useParams, useHistory } from "react-router-dom";
import OrderFiles from "../orders/orders-single/order-components/orderFiles/orderFiles";

import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import * as Yup from "yup";
import {
  Formik,
  Field,
  Form,
  FieldArray,
  ErrorMessage,
  getIn,
} from "formik";
import "./InstanceCustomers.css";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import ButtonLoader from "../../../../components/ButtonLoader/index.js";
import { AuthContext } from "../../../../helpers/AuthContext";
import useWorkflowDisplaySettings from "../../../../hooks/useWorkflowDisplaySettings";
import { requestCustomerConversion } from "../../../../services/customer";
import CustomerReviewShortcut from "./CustomerReviewShortcut";
import CustomerDuplicateSuggestions from "./CustomerDuplicateSuggestions";
import CustomerContactRepairDialog from "./CustomerContactRepairDialog";

// Import OrderUserAssignment (adjust the path as needed)
import OrderUserAssignment from "../orders/orders-single/order-components/orderUserAssignment/OrderUserAssignment";

import ChatBox from "./ChatBox";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ChatIcon from "@mui/icons-material/Chat";
import QboCustomerLinkDialog from "../../../../components/QboCustomerLinkDialog";

import { useTheme } from "@mui/material/styles";
// import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
// import SettingsIcon from "@mui/icons-material/Settings";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ClearIcon from "@mui/icons-material/Clear";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import {
  UIStatusChip,
  UITableShell,
  UITableToolbar,
} from "../../../../components/ui";
import { getIndustryOptions } from "../../../../constants/industries";
import {
  getOverviewSaveErrors,
  overviewFieldLabels,
} from "./customerOverviewErrors";
import { customerOverviewValidationSchema } from "./customerOverviewValidation";
import {
  canEditCoreCustomerFields,
  canEditCustomerContactFields,
  canEditCustomerAssignments,
} from "./customerEditPermissions";
import {
  customerAddressValidationSchema,
  CUSTOMER_ADDRESS_COUNTRY_OPTIONS,
  getCustomerAddressRegionLabel,
  mapAddressErrorsToFormik,
  mapAddressTouchedToFormik,
  normalizeCustomerAddressCountry,
} from "./customerAddressValidation";
import SmartAddressAutocomplete from "../../../../components/SmartAddressAutocomplete";
import { CUSTOMER_ADDRESS_TYPE_OPTIONS, normalizeCustomerAddressType } from "../../../../utils/customerAddressTypes";
import { getGooglePlacesBrowserConfig } from "../../../../services/googlePlaces";

// -------------------------------------------------------------------
// Helper Function: Build Full Logo URL
// -------------------------------------------------------------------
const getFullLogoUrl = (logoPreview) => {
  if (!logoPreview) return "";
  if (logoPreview.startsWith("uploads")) {
    return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${logoPreview}`;
  }
  return logoPreview;
};

const LEGACY_SO_DISPLAY_MAP = {
  "sent for agreement": "Agreement Pending",
  rejected: "Client Change Requested",
  "changes requested": "Client Change Requested",
  completed: "Client Approved",
  "sales order ready": "Client Approved",
  "customer signed": "Client Approved",
  "ready to be invoiced": "Ready to be Invoiced",
};

const canonicalizeSoDisplay = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return raw;
  const mapped = LEGACY_SO_DISPLAY_MAP[raw.toLowerCase()];
  return mapped || raw;
};


const CUSTOMER_RECORD_BATCH_SIZE = 10;
const CUSTOMER_CONTACT_SEARCH_FIELDS = ["firstName", "lastName", "email", "phone", "title", "note", "contactId"];
const CUSTOMER_ADDRESS_SEARCH_FIELDS = ["addressName", "addressType", "street", "streetAddress", "suiteApt", "city", "state", "postal", "country", "id"];

// Search the entire Formik value array while mounting only ten editable cards at a time.
function CustomerRecordBrowser({ items, fields, label, children, isHidden = null }) {
  const [query, setQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(CUSTOMER_RECORD_BATCH_SIZE);
  const sentinelRef = useRef(null);
  const scrollParentRef = useRef(null);
  const normalizedQuery = query.trim().toLocaleLowerCase();
  const matchingIndices = useMemo(() => items.reduce((matches, item, index) => {
    if (isHidden?.(item)) return matches;
    if (!normalizedQuery || fields.some((field) =>
      String(item?.[field] ?? "").toLocaleLowerCase().includes(normalizedQuery))) matches.push(index);
    return matches;
  }, []), [items, fields, normalizedQuery, isHidden]);
  const visibleIndices = matchingIndices.slice(0, visibleCount);
  const hasMore = visibleCount < matchingIndices.length;

  useEffect(() => {
    setVisibleCount(CUSTOMER_RECORD_BATCH_SIZE);
  }, [normalizedQuery]);

  useEffect(() => {
    const dialogScroll = document.querySelector(".MuiDialogContent-root");
    if (!dialogScroll) return undefined;
    scrollParentRef.current = dialogScroll;
    return () => {
      scrollParentRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!hasMore || !sentinelRef.current || !scrollParentRef.current) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        setVisibleCount((count) => Math.min(count + CUSTOMER_RECORD_BATCH_SIZE, matchingIndices.length));
      }
    }, { root: scrollParentRef.current, rootMargin: "0px 0px 160px 0px" });
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, matchingIndices.length, visibleCount]);

  return (
    <Box sx={{ minWidth: 0, position: "relative" }}>
      <TextField fullWidth size="small" label={`Search ${label}`}
        placeholder={`Search all ${label.toLowerCase()}...`} value={query}
        onChange={(event) => setQuery(event.target.value)}
        sx={{ mb: 1.5 }} inputProps={{ "aria-label": `Search all ${label.toLowerCase()}` }} />
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
        {matchingIndices.length} {label.toLowerCase()} found · Showing {visibleIndices.length}
      </Typography>
      {children(visibleIndices)}
      {!matchingIndices.length && <Typography color="text.secondary" sx={{ py: 3, textAlign: "center" }}>
        No matching {label.toLowerCase()}.
      </Typography>}
      {hasMore && <Box ref={sentinelRef} sx={{ py: 1, textAlign: "center" }}>
        <Button size="small" onClick={() => setVisibleCount((count) =>
          Math.min(count + CUSTOMER_RECORD_BATCH_SIZE, matchingIndices.length))}>
          Load 10 more
        </Button>
      </Box>}

    </Box>
  );
}


function CustomerStickyActions({ isSubmitting, onClose, label, recordCount }) {
  const isSticky = recordCount > CUSTOMER_RECORD_BATCH_SIZE;
  const footerRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const scrollRef = useRef(null);
  useEffect(() => {
    const scrollContainer = footerRef.current?.closest(".MuiDialogContent-root");
    scrollRef.current = scrollContainer;
    if (!scrollContainer) return undefined;
    const update = () => setScrolled(scrollContainer.scrollTop > 220);
    update();
    scrollContainer.addEventListener("scroll", update, { passive: true });
    return () => {
      scrollContainer.removeEventListener("scroll", update);
      scrollRef.current = null;
    };
  }, []);
  return (
    <DialogActions ref={footerRef} className="customer-detail-dialog-actions" sx={{
      position: isSticky ? "sticky" : "static", bottom: isSticky ? 0 : "auto", zIndex: isSticky ? 10 : "auto",
      bgcolor: "background.paper", borderTop: "1px solid",
      borderColor: "divider", boxShadow: isSticky ? "0 -6px 20px rgba(15, 23, 42, 0.09)" : "none",
      px: { xs: 2.5, sm: 3 }, py: 1.5, mx: 0, mt: 2,
      width: "100%", boxSizing: "border-box", borderRadius: 1,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: 1, "&.MuiDialogActions-root": { justifyContent: "space-between", px: { xs: 2.5, sm: 3 } },
    }}>
      <Box sx={{ minWidth: 0 }}>
        {isSticky && scrolled && (
          <Tooltip title="Scroll to top">
            <Button size="small" type="button" startIcon={<ExpandMoreIcon sx={{ transform: "rotate(180deg)" }} />}
              onClick={() => scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" })}
              sx={{ textTransform: "none", fontWeight: 600 }}>
              Back to top
            </Button>
          </Tooltip>
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button type="submit" color="primary" disabled={isSubmitting}>
          {isSubmitting ? <ButtonLoader /> : `Save ${label}`}
        </Button>
        <Button type="button" onClick={onClose} color="secondary">Cancel</Button>
      </Box>
    </DialogActions>
  );
}

const normalizeEditableClientContact = (contact = {}) => ({
  ...contact,
  firstName: contact?.firstName || "",
  lastName: contact?.lastName || "",
  email: contact?.email || "",
  phone: contact?.phone || "",
  title: contact?.title || "",
  isActive: contact?.isActive !== false,
  note: contact?.note || "",
});

const getContactDisplayName = (contact = {}, index = 0) => {
  const fullName = [contact?.firstName, contact?.lastName].filter(Boolean).join(" ").trim();
  return fullName || `Contact ${index + 1}`;
};

const getContactInitials = (contact = {}, index = 0) => {
  const initials = [contact?.firstName, contact?.lastName]
    .filter(Boolean)
    .map((value) => String(value).trim().charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);

  return initials || `C${index + 1}`.slice(0, 2);
};

const getAddressDisplayName = (address = {}, index = 0) =>
  String(address?.addressName || "").trim() || `Address ${index + 1}`;

const isAddressEmpty = (address = {}) =>
  ![
    address?.addressName,
    address?.street,
    address?.suiteApt,
    address?.city,
    address?.state,
    address?.postal,
    address?.country,
  ]
    .map((value) => String(value || "").trim())
    .some(Boolean);

const getAddressSummaryLines = (address = {}) => {
  const lineOne = [address?.street, address?.suiteApt].filter(Boolean).join(", ").trim();
  const lineTwo = [
    String(address?.city || "").trim(),
    [String(address?.state || "").trim(), String(address?.postal || "").trim()]
      .filter(Boolean)
      .join(" "),
  ]
    .filter(Boolean)
    .join(", ");
  const country = String(address?.country || "").trim();
  const lines = [lineOne, lineTwo, country].filter(Boolean);

  if (!lines.length) {
    return ["Address details not entered yet"];
  }

  return lines;
};

const SO_STATUS_TONES = {
  "Quote Requested": "info",
  Waiting: "warning",
  "Presentation Draft": "neutral",
  "Presentation Sent": "info",
  "Estimate Draft": "neutral",
  "Estimate Sent": "info",
  "Agreement Pending": "warning",
  "Agreement Sent": "info",
  "Client Change Requested": "error",
  "Client Approved": "success",
  "In Production": "accent",
  Shipped: "info",
  "Ready to be Invoiced": "warning",
  Invoiced: "success",
  Closed: "neutral",
};

const PO_STATUS_TONES = {
  Created: "info",
  Submitted: "info",
  Confirmed: "success",
  "Follow Up": "warning",
  Open: "info",
  Shipped: "accent",
  Received: "success",
  "Partially Received": "warning",
  "Ready For Billing": "warning",
  Closed: "neutral",
  Billed: "success",
};

const getSOStatusTone = (status) => SO_STATUS_TONES[status] || "neutral";
const getPOStatusTone = (status) => PO_STATUS_TONES[status] || "neutral";

const formatRoleLabel = (role) => {
  const raw = String(role || "").trim();
  if (!raw) return "System";
  return raw.replace(/[-_]/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
};

const formatActionLabel = (action) => {
  const raw = String(action || "").trim();
  if (!raw) return "Update";
  return raw.replace(/[-_]/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
};

const maybeRenderHtml = (value) =>
  /<\/?[a-z][\s\S]*>/i.test(String(value || ""));

const sanitizeNoteHtml = (raw) => {
  const text = String(raw || "");
  return text
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
    .replace(/\son\w+=(['"]).*?\1/gi, "")
    .replace(/\son\w+=([^\s>]+)/gi, "")
    .replace(/javascript:/gi, "");
};

const getNoteAvatarUrl = (avatarRaw) => {
  if (!avatarRaw) return "/elite-core-placeholder-avatar.png";
  try {
    const parsed =
      typeof avatarRaw === "string" ? JSON.parse(avatarRaw) : avatarRaw;
    if (Array.isArray(parsed)) {
      const selected = parsed.find((x) => x?.selected) || parsed[0];
      if (selected?.url) return selected.url;
    }
    if (typeof parsed === "string") return parsed;
  } catch (_) {
    if (typeof avatarRaw === "string") return avatarRaw;
  }
  return "/elite-core-placeholder-avatar.png";
};

const getApiErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again.",
) => {
  const response = error?.response?.data;
  const fieldError = response?.errors && Object.values(response.errors).find(Boolean);
  return response?.message || response?.error || fieldError || fallback;
};

// -------------------------------------------------------------------
// Helper Component: TabPanel
// -------------------------------------------------------------------
function TabPanel(props) {
  const { children, value, index, className, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`customer-tabpanel-${index}`}
      aria-labelledby={`customer-tab-${index}`}
      className={`customer-tabpanel ${className || ""}`}
      {...other}
    >
      {value === index && <Box className="customer-tabpanel-content" sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

// -------------------------------------------------------------------
// Helper Component: PopupActionsBar
// -------------------------------------------------------------------
const PopupActionsBar = ({
  actions,
  loading,
  buttonLabel = "Actions",
  buttonIcon = <SettingsIcon />,
  buttonStyles = {},
  dropdownStyles = {},
}) => {
  const [showActions, setShowActions] = useState(false);
  const handleActionsClick = () => setShowActions(!showActions);

  return (
    <div className="popup-actions-bar">
      <div className="dropdown-container">
        <Box
          className="introduction-field"
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Button
            variant="contained"
            onClick={handleActionsClick}
            sx={{
              textTransform: "none",
              color: "white",
              backgroundColor: "#c3171d",
              "&:hover": { backgroundColor: "white", color: "#c3171d" },
              width: "200px",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              ...buttonStyles,
            }}
          >
            {loading ? (
              "Loading..."
            ) : (
              <>
                {buttonIcon} {buttonLabel}
              </>
            )}
          </Button>
        </Box>
        {showActions && (
          <Box className="dropdown-menu" sx={{ ...dropdownStyles }}>
            {actions.map((action, index) => (
              <Button
                key={index}
                onClick={action.onClick}
                disabled={Boolean(action.disabled)}
                sx={{ width: "100%", marginBottom: "10px", fontWeight: 700 }}
              >
                {action.label}
              </Button>
            ))}
          </Box>
        )}
      </div>
    </div>
  );
};

// -------------------------------------------------------------------
// Helper Component: CustomerLogoCell
// Mimics supplier logo style using the same CSS classes
// -------------------------------------------------------------------
const CustomerLogoCell = ({ customer }) => {
  const [hasError, setHasError] = useState(false);
  const defaultLogo = "/default-customer-logo.png"; // Fallback image

  let logo = customer.customUploadedBrandLogo || "";
  if (logo && logo.startsWith("uploads")) {
    logo = `${process.env.REACT_APP_NODEJS_SERVER_URL}/${logo}`;
  }
  if (!logo) {
    logo = defaultLogo;
  }
  if (hasError) {
    return (
      <div className="fallback-logo">
        <ImageIcon />
      </div>
    );
  }
  return (
    <img
      src={logo}
      alt={`${customer.businessName || customer.businessName} Logo`}
      onError={() => setHasError(true)}
      className="supplier-logo-img custom-logo"
      style={{ width: 50, height: 50, objectFit: "contain" }}
    />
  );
};

// -------------------------------------------------------------------
// Mapping Function: Map Customer for Display
// -------------------------------------------------------------------
const mapCustomerForDisplay = (customer) => {
  return {
    id: customer.id,
    name:
      customer.businessName ||
      customer.businessName ||
      `${customer.firstName || ""} ${customer.lastName || ""}`.trim(),
    AssignedTo: customer.AssignedTo || "Unassigned",
    status: customer.status || "lead",
    clientContact: (() => {
      const contact = customer.clientContacts?.find((entry) => !entry?.mergedIntoContactId);
      if (!contact) return "N/A";
      // Only keep the defined name parts
      const parts = [contact.firstName, contact.lastName].filter(Boolean);
      return parts.length ? parts.join(" ") : "N/A";
    })(),
    logoUrl: getFullLogoUrl(customer.customUploadedBrandLogo),
    _raw: customer,
  };
};

const normalizeCustomerForModal = (c = {}) => ({
  ...c,
  businessName: c.businessName || c.name || c.companyName || "",
  emailAddress: c.emailAddress || c.email || c.primaryEmail || "",
  phoneNumber: c.phoneNumber || c.phone || c.primaryPhone || "",
  AssignedTo: c.AssignedTo || c.assignedTo || [],
  clientContacts: Array.isArray(c.clientContacts)
    ? c.clientContacts.map(normalizeEditableClientContact)
    : [],
  address: Array.isArray(c.addresses)
    ? c.addresses
    : Array.isArray(c.address)
    ? c.address
    : [],
});
 
const ALL_CUSTOMER_COLUMNS = [
  {
    id: "s_no",
    field: null,
    label: "#",
    sortable: false,
    minWidth: 55,
    align: "center",
    visible: true,
  },
  {
    id: "logo",
    field: null,
    label: "Logo",
    sortable: false,
    minWidth: 90,
    visible: true,
  },
  {
    id: "name",
    field: "name",
    label: "Account Name",
    sortable: true,
    minWidth: 220,
    visible: true,
  },
  {
    id: "activity",
    field: null,
    label: "Activity",
    sortable: false,
    minWidth: 120,
    visible: true,
  },
  {
    id: "assignedUsers",
    field: null,
    label: "Assigned",
    sortable: false,
    minWidth: 130,
    visible: true,
  },
  {
    id: "clientContact",
    field: "clientContact",
    label: "Client Contact",
    sortable: true,
    minWidth: 180,
    visible: true,
  },
  {
    id: "actions",
    field: null,
    label: "Actions",
    sortable: false,
    minWidth: 110,
    align: "center",
    visible: true,
    locked: true,
  },
];

const CUSTOMER_EXPORT_COLS = Object.freeze([
  { id: "name", label: "Account Name" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
  { id: "status", label: "Status" },
  { id: "clientContact", label: "Client Contact" },
  { id: "assigned", label: "Assigned Users" },
  { id: "createdAt", label: "Created" },
]);

const getCustomerExportVal = (row, id) => {
  const r = row._raw || row;
  switch (id) {
    case "name":
      return r.businessName || row.name || "";
    case "email":
      return r.emailAddress || "";
    case "phone":
      return r.phoneNumber || "";
    case "status":
      return r.status || "";
    case "clientContact":
      return row.clientContact || "";
    case "assigned":
      return Array.isArray(r.AssignedTo)
        ? r.AssignedTo.map((u) => u.role || u.id).join(", ")
        : "";
    case "createdAt":
      return r.createdAt
        ? new Date(r.createdAt).toLocaleDateString("en-CA", {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        : "";
    default:
      return "";
  }
};

// -------------------------------------------------------------------
// InstanceCustomers Component
// -------------------------------------------------------------------

const InstanceCustomers = () => {
  const history = useHistory();
  const location = useLocation();
  const { id: instanceId, instanceUniqueId } = useParams();
  const { authState } = useContext(AuthContext);
  const theme = useTheme();

  // server-driven state
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // ui state
  const [customerTab, setCustomerTab] = useState("myLeads"); // myLeads | myCustomers | all
  const [searchInput, setSearchInput] = useState("");
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
  const [assignedCustomerUserIds, setAssignedCustomerUserIds] = useState(null);
  // Only the directory sort preference is persisted; the assigned-user filter stays URL-driven.
  const [directorySort, setDirectorySort] = useState(() => {
    try {
      const saved = localStorage.getItem(`customerDirectorySort:${instanceUniqueId}`);
      return ["recent", "name-asc", "name-desc"].includes(saved) ? saved : "recent";
    } catch {
      return "recent";
    }
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(`customerDirectorySort:${instanceUniqueId}`);
      setDirectorySort(["recent", "name-asc", "name-desc"].includes(saved) ? saved : "recent");
    } catch {
      setDirectorySort("recent");
    }
  }, [instanceUniqueId]);

  useEffect(() => {
    if (!instanceUniqueId) return undefined;
    let active = true;
    axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}?archiveStatus=all`,
      { headers: { accessToken: localStorage.getItem("accessToken") } }
    ).then(({ data }) => {
      if (active) setAllUsers(data?.listOfUsers || []);
    }).catch((error) => console.error("Unable to load customer filter users", error));
    return () => { active = false; };
  }, [instanceUniqueId]);

  useEffect(() => {
    if (!instanceUniqueId) return undefined;
    let active = true;
    setAssignedCustomerUserIds(null);
    axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/customer-assigned-user-ids`,
      {
        params: { instanceUniqueId },
        headers: { accessToken: localStorage.getItem("accessToken") },
      }
    ).then(({ data }) => {
      if (active) setAssignedCustomerUserIds(new Set((data?.userIds || []).map(String)));
    }).catch((error) => {
      console.error("Unable to load assigned customer users", error);
      if (active) setAssignedCustomerUserIds(new Set());
    });
    return () => { active = false; };
  }, [instanceUniqueId]);

  const assignedUserOptions = useMemo(() => [...allUsers]
    .filter((user) => assignedCustomerUserIds?.has(String(user?.id)))
    .map((user) => ({
      id: String(user.id),
      label: [user.first_name || user.firstName, user.last_name || user.lastName]
        .filter(Boolean).join(" ").trim() || user.username || user.email || `User #${user.id}`,
      archived: user.archived === true || (!!user.archiveStatus && user.archiveStatus !== "active"),
    }))
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" })),
  [allUsers, assignedCustomerUserIds]);

  // const queryParams = new URLSearchParams(location.search);
  // const autoOpenCustomerId = queryParams.get("openCustomer");

  // // constants
  // const rpp = 25;
  // const pageGuard = useRef({ suppress: false });

  // // label for header
  // const pageLabel =
  //   customerTab === "myLeads"
  //     ? "My Leads"
  //     : customerTab === "myCustomers"
  //     ? "My Customers"
  //     : "All Accounts";

  // // helper: guarded navigation (prevents a stray onPageChange loop)
  // const navigate = (params, { replace = false } = {}) => {
  //   pageGuard.current.suppress = true;
  //   const method = replace ? "replace" : "push";
  //   history[method]({ pathname: location.pathname, search: params.toString() });
  // };



 
  const [density,           setDensity]          = useState("comfortable");
  const [visibleColumns,    setVisibleColumns]   = useState(
    () => new Set(ALL_CUSTOMER_COLUMNS.filter(c => c.visible !== false).map(c => c.id))
  );
  const [sortBy,            setSortBy]           = useState("");
  const [sortDir,           setSortDir]          = useState("asc");
  const [snackbar,          setSnackbar]         = useState({ open: false, message: "", severity: "success" });
  const [exportAnchorEl,    setExportAnchorEl]   = useState(null);
  const [columnMenuAnchor,  setColumnMenuAnchor] = useState(null);
  const [densityMenuAnchor, setDensityMenuAnchor]= useState(null);
  const [rowsPerPage,       setRowsPerPage]      = useState(25);

  const showSnackbar = (msg, sev = "success") => setSnackbar({ open: true, message: msg, severity: sev });

  const densitySettings = {
    compact:     { py: 0.75, fontSize: "0.8125rem" },
    comfortable: { py: 1.5,  fontSize: "0.875rem"  },
    spacious:    { py: 2.25, fontSize: "0.9375rem" },
  };
  const currentDensity = densitySettings[density];

 
  const C = {
    paperBg:        theme.palette.background.paper,
    subtleBg:       theme.palette.action.hover,
    border:         theme.palette.divider,
    textPri:        theme.palette.text.primary,
    textSec:        theme.palette.text.secondary,
    textMuted:      theme.palette.text.disabled,
    white:          theme.palette.common.white,
    headerBg:       theme.eliteCore?.tokens?.color?.neutral?.[800] || "#1e293b",
    headerBgHover:  theme.eliteCore?.tokens?.color?.neutral?.[700] || "#334155",
    headerText:     theme.eliteCore?.tokens?.color?.neutral?.[50]  || "#f8fafc",
    headerTextMuted:theme.eliteCore?.tokens?.color?.neutral?.[400] || "#94a3b8",
  };

  const queryParams      = new URLSearchParams(location.search);
  const autoOpenCustomerId = queryParams.get("openCustomer");
  const rpp              = rowsPerPage;
  const pageGuard        = useRef({ suppress: false });

  const pageLabel =
    customerTab === "myLeads"     ? "My Leads"    :
    customerTab === "myCustomers" ? "My Customers" : "All Accounts";

  const navigate = (params, { replace = false } = {}) => {
    pageGuard.current.suppress = true;
    history[replace ? "replace" : "push"]({ pathname: location.pathname, search: params.toString() });
  };


  // 1) server call
  const fetchCustomers = useCallback(
    async (page, q, tab, userId = "") => {
      if (!authState?.id) return; // need user id for "my*" tabs

      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/get-customers`,
          {
            params: {
              instanceUniqueId,
              page,
              rpp,
              q,
              tab,
              includeCurrentReview: true,
              ...(tab === "all"
                ? { accessContext: "customer-directory", sort: directorySort, ...(userId ? { assignedTo: userId } : {}) }
                : {}),
              ...(tab === "myLeads" || tab === "myCustomers"
                ? { assignedTo: authState.id, sort: directorySort }
                : {}),
            },
            headers: { accessToken: localStorage.getItem("accessToken") },
          },
        );

        const list = data.customers || data.Results || [];
        setCustomers(list.map(mapCustomerForDisplay));
        setTotal(data.total ?? list.length ?? 0);
        setTotalPages(
          data.totalPages ??
            Math.max(1, Math.ceil((data.total ?? list.length ?? 0) / rpp)),
        );
        setCurrentPage(data.page ?? page ?? 1);
      } catch (e) {
        console.error("Error fetching customers", e);
      } finally {
        setLoading(false);
      }
    },
    [authState?.id, instanceUniqueId, directorySort],
  );

  // 2) normalize URL on first load (defaults ?tab=myLeads&page=1)
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    let tab = p.get("tab") || "myLeads";
    let page = Math.max(parseInt(p.get("page") || "1", 10), 1);
    const q = p.get("q") || "";
    const userId = tab === "all" ? p.get("user") || "" : "";

    // if my* tab and we don't yet know user id, wait (prevents a flicker)
    if ((tab === "myLeads" || tab === "myCustomers") && !authState?.id) return;

    setCustomerTab(tab);
    setSearchInput(q);
    fetchCustomers(page, q, tab, userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, authState?.id, fetchCustomers]);

  // 3) auto-open detail modal via query (?openCustomer=ID)
  useEffect(() => {
    if (autoOpenCustomerId && customers.length) {
      const match = customers.find(
        (c) => String(c.id) === String(autoOpenCustomerId),
      );
      if (match) {
        setSelectedCustomer(normalizeCustomerForModal(match._raw));
        setShowDetailModal(true);
      }
    }
  }, [autoOpenCustomerId, customers]);

  // 4) tab bar (server-driven): clicking a tab resets q and page
  const CustomerSourceTabs = [
    {
      key: "myLeads",
      label: "My Leads",
      icon: PersonIcon,
      tooltip: "Leads assigned to me",
    },
    {
      key: "myCustomers",
      label: "My Customers",
      icon: PersonIcon,
      tooltip: "Active customers assigned to me",
    },
    {
      key: "all",
      label: "All",
      icon: GroupIcon,
      tooltip: "All leads and customers",
    },
  ];

  // 5) search submit → set ?q=&page=1&tab=
  const submitSearch = () => {
    const q = searchInput.trim();
    const p = new URLSearchParams(location.search);
    p.set("tab", customerTab);
    if (q) p.set("q", q);
    else p.delete("q");
    p.set("page", "1");
    navigate(p);
  };

    const selectedAssignedUser = customerTab === "all" ? queryParams.get("user") || "" : "";
    const hasActiveFilters = !!searchInput.trim() || !!selectedAssignedUser;

      const handleClearFilters = () => {
    setSearchInput("");
    const p = new URLSearchParams();
    p.set("tab", customerTab);
    p.set("page", "1");
    navigate(p);
  };


  // 6) pagination
  const gotoPage = (nextPage) => {
    const safe = Math.max(1, Math.min(nextPage, totalPages || 1));
    const p = new URLSearchParams(location.search);
    p.set("tab", customerTab);
    const q = searchInput.trim();
    if (q) p.set("q", q);
    else p.delete("q");
    p.set("page", String(safe));
    navigate(p);
  };

  // 7) row click → open detail
  const handleRowClick = (paramsOrRow) => {
    const row = paramsOrRow?.row || paramsOrRow;
    const rawCustomer = row?._raw || row;

    if (!rawCustomer) {
      console.warn("handleRowClick called without a valid customer row", paramsOrRow);
      return;
    }

    setSelectedCustomer(normalizeCustomerForModal(rawCustomer));
    setShowDetailModal(true);
  };

  // 8) create/update callbacks (prepend/patch client list)
  const handleNewCustomerCreated = (newCustomer) => {
    setCustomers((prev) => [mapCustomerForDisplay(newCustomer), ...prev]);
  };
  const handleCustomerUpdated = (updated) => {
    const isArchived = String(updated?.status || "").trim().toLowerCase() === "archived";
    setCustomers((prev) => {
      if (isArchived && customerTab !== "all") {
        return prev.filter((c) => c.id !== updated.id);
      }
      return prev.map((c) =>
        c.id === updated.id ? mapCustomerForDisplay(updated) : c,
      );
    });
    if (selectedCustomer?.id === updated.id) setSelectedCustomer(updated);
  };

  // 9) assigned avatars helper (same as your orders screen)
  const getUserAvatarUrl = (user) => {
    if (!user || !user.profilePicture) return null;
    let profilePic = user.profilePicture;
    if (Array.isArray(profilePic)) {
      const sel = profilePic.find((p) => p.selected) || profilePic[0];
      if (sel?.url)
        return sel.url.startsWith("uploads")
          ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${sel.url}`
          : sel.url;
    }
    if (typeof profilePic === "string") {
      try {
        const parsed = JSON.parse(profilePic);
        if (Array.isArray(parsed) && parsed.length) {
          const sel = parsed.find((p) => p.selected) || parsed[0];
          if (sel?.url)
            return sel.url.startsWith("uploads")
              ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${sel.url}`
              : sel.url;
        }
      } catch {
        return profilePic.startsWith("uploads")
          ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${profilePic}`
          : profilePic;
      }
    }
    return null;
  };

  const AssignedUsersColumn = ({ assigned, allUsers }) => {
    const merged = (assigned || []).map(
      (u) => allUsers.find((x) => x.id === u.id) || u,
    );
    const toShow = merged.slice(0, 2);
    return (
      <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
        {toShow.map((u) => {
          const avatarUrl = getUserAvatarUrl(u);
          const initials = !avatarUrl && u.first_name?.[0]?.toUpperCase();
          return (
            <Avatar
              key={u.id}
              src={avatarUrl || undefined}
              sx={{ width: 30, height: 30, mr: 0.5 }}
            >
              {initials || "?"}
            </Avatar>
          );
        })}
        {merged.length > 2 && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              bgcolor: "#fef2f2",
              borderRadius: "50%",
              px: 0.5,
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            +{merged.length - 2}
          </Box>
        )}
      </Box>
    );
  };

   const AssignedUsersCell = ({ assigned }) => {
    const merged  = (assigned || []).map(u => allUsers.find(x => x.id === u.id) || u);
    const toShow  = merged.slice(0, 2);
    return (
      <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
        {toShow.map(u => {
          const url      = getUserAvatarUrl(u);
          const initials = !url && u.first_name?.[0]?.toUpperCase();
          return (
            <Avatar key={u.id} src={url || undefined} sx={{ width: 30, height: 30, mr: 0.5 }}>
              {initials || "?"}
            </Avatar>
          );
        })}
        {merged.length > 2 && (
          <Box sx={{ position:"absolute", top:0, right:0, bgcolor:"#fef2f2", borderRadius:"50%", px:0.5, fontSize:12, fontWeight:700, lineHeight:1 }}>
            +{merged.length - 2}
          </Box>
        )}
      </Box>
    );
  };

 
  const handleSort = colId => {
    if (sortBy === colId) {
      if (sortDir === "asc") setSortDir("desc");
      else { setSortBy(""); setSortDir("asc"); }
    } else {
      setSortBy(colId);
      setSortDir("asc");
    }
  };

  const sortedCustomers = useMemo(() => {
    if (!sortBy) return customers;
    return [...customers].sort((a, b) => {
      const aVal = String(a[sortBy] ?? "");
      const bVal = String(b[sortBy] ?? "");
      return sortDir === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    });
  }, [customers, sortBy, sortDir]);

 
  const toggleColVisibility = colId => setVisibleColumns(prev => {
    const next = new Set(prev);
    next.has(colId) ? next.delete(colId) : next.add(colId);
    return next;
  });

 
  const exportCSV = () => {
    const rows = [CUSTOMER_EXPORT_COLS.map(c => c.label).join(",")];
    sortedCustomers.forEach(o => {
      rows.push(CUSTOMER_EXPORT_COLS.map(c => `"${String(getCustomerExportVal(o, c.id)).replace(/"/g,'""')}"`).join(","));
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" }));
    a.download = `customers_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    showSnackbar("CSV exported successfully");
  };

  const exportExcel = () => {
    const rows = [CUSTOMER_EXPORT_COLS.map(c => c.label).join("\t")];
    sortedCustomers.forEach(o => rows.push(CUSTOMER_EXPORT_COLS.map(c => getCustomerExportVal(o, c.id)).join("\t")));
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "application/vnd.ms-excel" }));
    a.download = `customers_${new Date().toISOString().split("T")[0]}.xls`;
    a.click();
    showSnackbar("Excel exported successfully");
  };

  const exportPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text(`${pageLabel} Report`, 14, 15);
    doc.setFontSize(9);
    doc.text(`Generated: ${new Date().toLocaleString()}   Total: ${total}`, 14, 22);
    autoTable(doc, {
      head: [CUSTOMER_EXPORT_COLS.map(c => c.label)],
      body: sortedCustomers.map(o => CUSTOMER_EXPORT_COLS.map(c => getCustomerExportVal(o, c.id))),
      startY: 28,
      styles: { fontSize: 7, cellPadding: 1.5, overflow: "ellipsize" },
      headStyles: { fillColor: [30,41,59], textColor: [255,255,255], fontStyle: "bold" },
      alternateRowStyles: { fillColor: [248,250,252] },
    });
    doc.save(`customers_${new Date().toISOString().split("T")[0]}.pdf`);
    showSnackbar("PDF exported successfully");
  };
 
  const renderCell = (col, row, index) => {
    const customer = row._raw || row;

    if (col.id === "s_no") return (currentPage - 1) * rowsPerPage + index + 1;

    if (col.id === "logo") {
      const rawStatus = customer.status || "";
      let tooltipText, StatusIcon, iconSx;
      if      (rawStatus === "lead")                                        { tooltipText = "Lead";                    StatusIcon = LightbulbIcon;   iconSx = { color: "#179ea5" }; }
      else if (rawStatus === "in-review")                                   { tooltipText = "Pending review";         StatusIcon = HourglassFullIcon;iconSx = { color: "warning.main" }; }
      else if (rawStatus === "Active" || rawStatus === "customer")          { tooltipText = "Approved customer";      StatusIcon = CheckCircleIcon;  iconSx = { color: "success.main" }; }
      else if (String(rawStatus).toLowerCase() === "archived")               { tooltipText = "Archived customer";      StatusIcon = FolderOffIcon;     iconSx = { color: "text.disabled" }; }
      return (
        <Box sx={{ display:"flex", alignItems:"center", gap:1 }}>
          <CustomerLogoCell customer={customer} />
          {StatusIcon && <Tooltip title={tooltipText}><StatusIcon sx={iconSx} /></Tooltip>}
        </Box>
      );
    }

    if (col.id === "name") {
      return (
        <Typography variant="body2" fontWeight={600} sx={{ color: C.textPri }}>
          {row.name}
        </Typography>
      );
    }

    if (col.id === "activity") {
      const { createdAt, updatedAt } = customer;
      const c    = new Date(createdAt).getTime();
      const u    = new Date(updatedAt).getTime();
      const base = c === u ? c : u;
      const diffMs  = Date.now() - base;
      const diffHr  = Math.floor(diffMs / 1000 / 60 / 60);
      if (diffHr < 24) {
        const diffMin = Math.floor(diffMs / 1000 / 60);
        const diffSec = Math.floor(diffMs / 1000);
        const label   = diffSec < 60 ? `${diffSec}s ago` : diffMin < 60 ? `${diffMin}m ago` : `${diffHr}h ago`;
        return (
          <Box sx={{ display:"flex", alignItems:"center", gap:0.5 }}>
            <WhatshotIcon color="error" fontSize="small" />
            <Typography variant="body2" color="error">{label}</Typography>
          </Box>
        );
      }
      return (
        <Typography variant="body2" color="text.secondary">
          {Math.floor(diffHr / 24)}d ago
        </Typography>
      );
    }

    if (col.id === "assignedUsers") {
      return <AssignedUsersCell assigned={customer.AssignedTo || []} />;
    }

    if (col.id === "clientContact") {
      return <Typography variant="body2">{row.clientContact}</Typography>;
    }

    if (col.id === "actions") {
      return (
        <Button
          variant="outlined"
          size="small"
          startIcon={<VisibilityIcon sx={{ fontSize: "0.85rem !important" }} />}
          onClick={e => { e.stopPropagation(); handleRowClick(row); }}
          sx={{ fontSize:"0.72rem", height:28, borderRadius:"8px", textTransform:"none", fontWeight:600, minWidth:76 }}
        >
          View
        </Button>
      );
    }

    return row[col.id] ?? "—";
  };


  // 10) columns (unchanged visuals, but no client-side filtering)
  const columns = useMemo(() => {
    const logoCol = {
      field: "logo",
      headerName: "Logo",
      width: 120,
      renderCell: (params) => {
        const customer = params.row._raw;
        const rawStatus = customer.status || "";
        let tooltipText, StatusIcon, iconSx;
        if (rawStatus === "lead") {
          tooltipText = "Lead";
          StatusIcon = LightbulbIcon;
          iconSx = { color: "#179ea5" };
        } else if (rawStatus === "in-review") {
          tooltipText = "Currently being reviewed for approval";
          StatusIcon = HourglassFullIcon;
          iconSx = { color: "warning.main" };
        } else if (rawStatus === "Active" || rawStatus === "customer") {
          tooltipText = "Customer is approved";
          StatusIcon = CheckCircleIcon;
          iconSx = { color: "success.main" };
        } else if (String(rawStatus).toLowerCase() === "archived") {
          tooltipText = "Archived customer";
          StatusIcon = FolderOffIcon;
          iconSx = { color: "text.disabled" };
        }
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CustomerLogoCell customer={customer} />
            {StatusIcon && (
              <Tooltip title={tooltipText}>
                <StatusIcon sx={iconSx} />
              </Tooltip>
            )}
          </div>
        );
      },
    };

    const nameCol = {
      field: "name",
      headerName: "Account Name",
      width: 250,
      renderCell: (p) => <span>{p.row.name}</span>,
    };

    const activityCol = {
      field: "activity",
      headerName: "Activity",
      width: 120,
      renderCell: (p) => {
        const { createdAt, updatedAt } = p.row._raw;
        const c = new Date(createdAt).getTime();
        const u = new Date(updatedAt).getTime();
        const base = c === u ? c : u;
        const diffMs = Date.now() - base;
        const diffHr = Math.floor(diffMs / 1000 / 60 / 60);
        if (diffHr < 24) {
          const diffMin = Math.floor(diffMs / 1000 / 60);
          const diffSec = Math.floor(diffMs / 1000);
          const label =
            diffSec < 60
              ? `${diffSec}s ago`
              : diffMin < 60
              ? `${diffMin}m ago`
              : `${diffHr}h ago`;
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <WhatshotIcon color="error" fontSize="small" />
              <Typography variant="body2" color="error">
                {label}
              </Typography>
            </Box>
          );
        }
        const diffDay = Math.floor(diffHr / 24);
        return `${diffDay}d ago`;
      },
    };

    const assignedCol = {
      field: "assignedUsers",
      headerName: "Assigned Users",
      width: 150,
      renderCell: (p) => (
        <AssignedUsersColumn
          assigned={p.row._raw.AssignedTo || []}
          allUsers={allUsers}
        />
      ),
    };

    const contactCol = {
      field: "clientContact",
      headerName: "Client Contact",
      width: 200,
      valueGetter: (value, row) => row?.clientContact,
    };

    return [logoCol, nameCol, activityCol, assignedCol, contactCol];
  }, [allUsers]);

  // 11) tabs UI config + search label
  const searchLabel =
    customerTab === "myLeads"
      ? "Search leads"
      : customerTab === "myCustomers"
      ? "Search customers"
      : "Search all (leads & customers)";

//   return (
//     <div className="instance-dashboard">
//       <InstanceLeftSidebar />
//       <div className="rightSide">
//         <div className="options-container fade-in-effect-usability">
//           <div className="options-inner-container">
//             <PageHeaderWithBreadcrumbs
//               title={pageLabel}
//               breadcrumb={pageLabel + " List"}
//               includeButton={false}
//             />

            
//             <div className="tabs customer-tabs">
//               {CustomerSourceTabs.map(({ key, label, icon: Icon, tooltip }) => (
//                 <Tooltip key={key} title={tooltip} placement="bottom">
//                   <button
//                     className={`tab-btn${customerTab === key ? " active" : ""}`}
//                     onClick={() => {
//                       setCustomerTab(key);
//                       setSearchInput("");
//                       const p = new URLSearchParams();
//                       p.set("tab", key);
//                       p.set("page", "1");
//                       navigate(p);
//                     }}
//                   >
//                     <Icon style={{ marginRight: 6, verticalAlign: "middle" }} />
//                     {label}
//                   </button>
//                 </Tooltip>
//               ))}
//             </div>

            
//             <div className="actionBar">
//               {customerTab === "myLeads" ? (
//                 <button onClick={() => setShowCustomerModal(true)}>
//                   New Lead
//                 </button>
//               ) : (
//                 <button onClick={() => setShowCustomerModal(true)}>
//                   New Customer
//                 </button>
//               )}

//               <div className="search-container">
//                 <TextField
//                   label={searchLabel}
//                   variant="outlined"
//                   size="small"
//                   value={searchInput}
//                   onChange={(e) => setSearchInput(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       e.preventDefault();
//                       submitSearch();
//                     }
//                   }}
//                 />
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={submitSearch}
//                 >
//                   Search
//                 </Button>
//               </div>
//             </div>

           
//             {loading ? (
//               <p>Loading...</p>
//             ) : (
//               <DataTable
//                 key={customerTab} // force grid to reset when switching tabs
//                 columns={columns}
//                 rows={customers}
//                 rowCount={total} // <-- total from server
//                 page={currentPage} // <-- 1-based page you track
//                 pageSize={rpp} // 25
//                 onPageChange={(nextPage) => gotoPage(nextPage)} // DataGrid gives 1-based from our wrapper
//                 onRowClick={handleRowClick}
//                 getRowId={(row) => row.id}
//               />
//             )}
//           </div>
//         </div>
//       </div>

      
//       {showCustomerModal && (
//         <CustomerModal
//           open={showCustomerModal}
//           onClose={() => setShowCustomerModal(false)}
//           onCustomerCreated={handleNewCustomerCreated}
//           viewScreen={pageLabel}
//           existingCustomers={customers}
//         />
//       )}

//       {showDetailModal && selectedCustomer && (
//         <CustomerDetailModal
//           open={showDetailModal}
//           onClose={() => setShowDetailModal(false)}
//           customer={selectedCustomer}
//           onCustomerUpdated={handleCustomerUpdated}
//           viewScreen={pageLabel}
//         />
//       )}
//     </div>
//   );
// };

// export default InstanceCustomers;

 
  return (
    <div className="instance-dashboard">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
        }}
      />
      <InstanceLeftSidebar />

      <div className="rightSide">
        <Box sx={{ p: { xs:1, md:2 }, display:"flex", flexDirection:"column", height:"calc(100vh - 60px)", overflow:"hidden", width: "100%" }}>
          <UITableShell
            customLayout
            paperSx={{
              flex: 1,
              borderRadius: "10px",
              border: "1px solid",
              borderColor: "divider",
              borderTop: "3px solid",
              borderTopColor: "primary.main",
              minHeight: 0,
              boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
            }}
          >
           
            <UITableToolbar sx={{ backgroundColor: C.paperBg }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5}>

         
                <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap>
                  <Typography variant="h6" fontWeight={700} sx={{ color: C.textPri, lineHeight:1 }}>
                    {pageLabel}
                  </Typography>

                  <Chip
                    label={`${total} total`}
                    size="small"
                    sx={{ backgroundColor:"var(--ec-status-neutral-bg)", color:"var(--ec-status-neutral-text)", border:"1px solid var(--ec-status-neutral-border)", fontWeight:600, fontSize:"0.72rem", height:22 }}
                  />

                  <Divider orientation="vertical" flexItem sx={{ height:20, alignSelf:"center" }} />

                  <Stack direction="row" spacing={0.5}>
                    {CustomerSourceTabs.map(({ key, label, tooltip }) => (
                      <Tooltip key={key} title={tooltip} placement="bottom">
                        <Chip
                          label={label}
                          size="small"
                          onClick={() => {
                            setCustomerTab(key);
                            setSearchInput("");
                            const p = new URLSearchParams();
                            p.set("tab", key);
                            p.set("page", "1");
                            navigate(p);
                          }}
                          sx={{
                            cursor:"pointer", fontWeight:600, fontSize:"0.72rem", height:26,
                            backgroundColor: customerTab === key ? "var(--ec-color-primary)"       : "var(--ec-status-neutral-bg)",
                            color:           customerTab === key ? "var(--ec-color-surface)"        : "var(--ec-status-neutral-text)",
                            border:          customerTab === key ? "1px solid transparent"          : "1px solid var(--ec-status-neutral-border)",
                            transition: "all 0.15s ease",
                            "& .MuiChip-label": { px:"10px" },
                            "&:hover": { backgroundColor: customerTab === key ? "var(--ec-color-primary-dark)" : "var(--ec-color-surface-muted)" },
                          }}
                        />
                      </Tooltip>
                    ))}
                  </Stack>
                </Stack>

             
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <Tooltip title="Export data">
                    <IconButton size="small" onClick={e => setExportAnchorEl(e.currentTarget)} disabled={sortedCustomers.length === 0} sx={{ color:"text.secondary" }}>
                      <DownloadIcon sx={{ fontSize:18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu anchorEl={exportAnchorEl} open={Boolean(exportAnchorEl)} onClose={() => setExportAnchorEl(null)} slotProps={{ paper:{ sx:{ minWidth:190, borderRadius:2 } } }}>
                    <Typography variant="overline" sx={{ px:2, pt:1.25, pb:0.5, display:"block", color:"text.disabled" }}>Export as</Typography>
                    <Divider sx={{ mb:0.5 }} />
                    <MenuItem onClick={() => { exportCSV();   setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><FileDownloadIcon  fontSize="small" /></ListItemIcon><ListItemText>CSV</ListItemText></MenuItem>
                    <MenuItem onClick={() => { exportExcel(); setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><TableChartIcon    fontSize="small" /></ListItemIcon><ListItemText>Excel</ListItemText></MenuItem>
                    <MenuItem onClick={() => { exportPDF();   setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><PictureAsPdfIcon  fontSize="small" /></ListItemIcon><ListItemText>PDF</ListItemText></MenuItem>
                  </Menu>

                  <Tooltip title="Show / hide columns">
                    <IconButton size="small" onClick={e => setColumnMenuAnchor(e.currentTarget)} sx={{ color:"text.secondary" }}>
                      <ViewColumnIcon sx={{ fontSize:18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu anchorEl={columnMenuAnchor} open={Boolean(columnMenuAnchor)} onClose={() => setColumnMenuAnchor(null)} slotProps={{ paper:{ sx:{ minWidth:210, borderRadius:2 } } }}>
                    <Typography variant="overline" sx={{ px:2, pt:1.25, pb:0.5, display:"block", color:"text.disabled" }}>Columns</Typography>
                    <Divider sx={{ mb:0.5 }} />
                    {ALL_CUSTOMER_COLUMNS.filter(c => !c.locked).map(col => (
                      <MenuItem key={col.id} onClick={() => toggleColVisibility(col.id)} sx={{ py:0.4 }}>
                        <Checkbox size="small" checked={visibleColumns.has(col.id)} sx={{ p:0.5, mr:0.5, color:"primary.main", "&.Mui-checked":{ color:"primary.main" } }} />
                        <ListItemText primaryTypographyProps={{ fontSize:"0.875rem" }}>{col.label}</ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  <Tooltip title="Row density">
                    <IconButton size="small" onClick={e => setDensityMenuAnchor(e.currentTarget)} sx={{ color:"text.secondary" }}>
                      <SettingsIcon sx={{ fontSize:18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu anchorEl={densityMenuAnchor} open={Boolean(densityMenuAnchor)} onClose={() => setDensityMenuAnchor(null)} slotProps={{ paper:{ sx:{ minWidth:180, borderRadius:2 } } }}>
                    <Typography variant="overline" sx={{ px:2, pt:1.25, pb:0.5, display:"block", color:"text.disabled" }}>Row density</Typography>
                    {["compact","comfortable","spacious"].map(d => (
                      <MenuItem key={d} onClick={() => { setDensity(d); setDensityMenuAnchor(null); }} sx={{ py:0.75, textTransform:"capitalize" }}>
                        <Checkbox size="small" checked={density === d} sx={{ p:0.5, mr:0.5, color:"primary.main", "&.Mui-checked":{ color:"primary.main" } }} />
                        <ListItemText primaryTypographyProps={{ fontSize:"0.875rem", textTransform:"capitalize" }}>{d}</ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  <Tooltip title="Refresh list">
                    <IconButton size="small" onClick={() => { fetchCustomers(currentPage, searchInput, customerTab, selectedAssignedUser); showSnackbar("Refreshed"); }} sx={{ color:"text.secondary" }}>
                      <RefreshIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Divider orientation="vertical" flexItem sx={{ mx:0.5, height:24, alignSelf:"center" }} />

                  <Button
                    variant="contained" color="primary" size="small"
                    startIcon={<AddIcon />}
                    onClick={() => setShowCustomerModal(true)}
                    sx={{ fontWeight:700, textTransform:"none", height:34, px:2, whiteSpace:"nowrap" }}
                  >
                    {customerTab === "myLeads" ? "New Lead" : "New Customer"}
                  </Button>
                </Stack>
              </Stack>

              <Divider sx={{ mt:1.75, mb:0 }} />

          
              <Stack direction="row" spacing={1.5} mt={1.75} flexWrap="wrap" useFlexGap alignItems="center">
                <TextField
                  placeholder={
                    customerTab === "myLeads"     ? "Search leads…"                :
                    customerTab === "myCustomers" ? "Search customers…"             :
                                                   "Search all (leads & customers)…"
                  }
                  size="small"
                  value={searchInput}
                  onChange={e => setSearchInput(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); submitSearch(); } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize:16, color: C.textMuted }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchInput ? (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => setSearchInput("")} edge="end">
                          <ClearIcon sx={{ fontSize:14 }} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={{ flex:2, minWidth:280, "& .MuiOutlinedInput-root":{ backgroundColor:"var(--ec-input-bg)" } }}
                />

                <FormControl size="small" sx={{ minWidth: 180, flex: "1 1 180px", maxWidth: 230 }}>
                    <InputLabel id="customer-directory-sort-label">Sort by</InputLabel>
                    <Select
                      labelId="customer-directory-sort-label"
                      label="Sort by"
                      value={directorySort}
                      onChange={(event) => {
                        const nextSort = event.target.value;
                        setDirectorySort(nextSort);
                        try {
                          localStorage.setItem(`customerDirectorySort:${instanceUniqueId}`, nextSort);
                        } catch {
                          // Storage may be unavailable; sorting still works for this session.
                        }
                        const p = new URLSearchParams(location.search);
                        p.set("page", "1");
                        navigate(p);
                      }}
                      sx={{ backgroundColor: "var(--ec-input-bg)", height: 40 }}
                    >
                      <MenuItem value="recent">Recently updated</MenuItem>
                      <MenuItem value="name-asc">Name (A–Z)</MenuItem>
                      <MenuItem value="name-desc">Name (Z–A)</MenuItem>
                    </Select>
                  </FormControl>

                {customerTab === "all" && (
                  <FormControl size="small" sx={{ minWidth: 205, flex: "1 1 205px", maxWidth: 280 }}>
                    <InputLabel id="customer-assigned-user-filter-label">Assigned user</InputLabel>
                    <Select
                      labelId="customer-assigned-user-filter-label"
                      label="Assigned user"
                      value={selectedAssignedUser}
                      onChange={(event) => {
                        const p = new URLSearchParams(location.search);
                        if (event.target.value) p.set("user", event.target.value);
                        else p.delete("user");
                        p.set("page", "1");
                        navigate(p);
                      }}
                      sx={{ backgroundColor: "var(--ec-input-bg)", height: 40 }}
                    >
                      <MenuItem value="">All users</MenuItem>
                      {assignedUserOptions.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                          {user.label}{user.archived ? " (Archived)" : ""}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                <Button
                  variant="contained" size="small"
                  startIcon={<SearchIcon sx={{ fontSize:15 }} />}
                  onClick={submitSearch}
                  sx={{ height:40, textTransform:"none", fontWeight:600, px:2.5, boxShadow:"none", "&:hover":{ boxShadow:"none" } }}
                >
                  Search
                </Button>

                {hasActiveFilters && (
                  <Tooltip title="Clear all filters">
                    <Button
                      variant="text" size="small"
                      startIcon={<ClearIcon sx={{ fontSize:14 }} />}
                      onClick={handleClearFilters}
                      sx={{ height:40, textTransform:"none", fontWeight:600, color:"text.secondary", px:1.5, "&:hover":{ color:"error.main", backgroundColor:"var(--ec-status-error-bg)" } }}
                    >
                      Clear
                    </Button>
                  </Tooltip>
                )}
              </Stack>

       
              {hasActiveFilters && (
                <Stack direction="row" spacing={0.75} mt={1.25} flexWrap="wrap" useFlexGap alignItems="center">
                  <Typography variant="caption" sx={{ color: C.textMuted, fontWeight:600, mr:0.25 }}>Active filters:</Typography>
                  {searchInput && (
                    <Chip
                      label={`Search: "${searchInput}"`} size="small"
                      onDelete={() => { setSearchInput(""); handleClearFilters(); }}
                      sx={{ backgroundColor:"var(--ec-status-info-bg)", color:"var(--ec-status-info-text)", border:"1px solid var(--ec-status-info-border)", fontWeight:600, fontSize:"0.72rem" }}
                    />
                  )}
                  <Chip
                    label="Clear all" size="small" onClick={handleClearFilters}
                    sx={{ backgroundColor:"var(--ec-status-error-bg)", color:"var(--ec-status-error-text)", border:"1px solid var(--ec-status-error-border)", fontWeight:700, fontSize:"0.72rem", cursor:"pointer" }}
                  />
                </Stack>
              )}
            </UITableToolbar>

        
            <TableContainer
              sx={{
                flex:1, overflow:"auto", minHeight:0, borderRadius:"0 !important",
                "&::-webkit-scrollbar":{ width:6, height:6 },
                "&::-webkit-scrollbar-thumb":{ backgroundColor:"var(--ec-color-border-strong)", borderRadius:99 },
                "&::-webkit-scrollbar-track":{ backgroundColor:"transparent" },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth:800, width:"100%" }}>
                <TableHead>
                  <TableRow>
                    {ALL_CUSTOMER_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => (
                      <TableCell
                        key={col.id}
                        align={col.align || "left"}
                        onClick={() => col.sortable && handleSort(col.id)}
                        sx={{
                          minWidth: col.minWidth,
                          px:2, py:1.25,
                          backgroundColor: "var(--ec-table-head-bg-strong) !important",
                          color: sortBy === col.id ? "var(--ec-table-head-text-inverse)" : "var(--ec-table-head-text-muted)",
                          fontWeight:700, fontSize:"0.72rem", letterSpacing:"0.06em", textTransform:"uppercase",
                          borderBottom:"none", cursor: col.sortable ? "pointer" : "default", userSelect:"none", whiteSpace:"nowrap",
                          position:"sticky", top:0, zIndex:2, transition:"all 0.15s",
                          "&:hover": col.sortable ? { backgroundColor:"var(--ec-table-head-bg-hover) !important", color:"var(--ec-table-head-text-inverse)" } : {},
                        }}
                      >
                        <Box sx={{ display:"flex", alignItems:"center", gap:0.5, justifyContent: col.align === "center" ? "center" : "flex-start" }}>
                          {col.label}
                          {col.sortable && (
                            <Box sx={{ display:"inline-flex", ml:0.25, opacity: sortBy === col.id ? 1 : 0.4, color: sortBy === col.id ? "var(--ec-table-head-text-inverse)" : "var(--ec-color-text-muted)" }}>
                              {sortBy === col.id
                                ? sortDir === "asc" ? <ArrowUpwardIcon sx={{ fontSize:12 }} /> : <ArrowDownwardIcon sx={{ fontSize:12 }} />
                                : <UnfoldMoreIcon sx={{ fontSize:13 }} />}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody sx={{ "& .MuiTableCell-root":{ borderBottom:`1px solid ${C.border}` }, "& .MuiTableRow-root:last-child .MuiTableCell-root":{ borderBottom:"none" } }}>
                  {/* Loading skeleton */}
                  {loading && [...Array(8)].map((_, i) => (
                    <TableRow key={i}>
                      {ALL_CUSTOMER_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => (
                        <TableCell key={col.id} sx={{ px:2, py: currentDensity.py }}>
                          <Skeleton variant="rectangular" height={20} sx={{ borderRadius:1, opacity: 1 - i * 0.09 }} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}

                  {/* Empty state */}
                  {!loading && sortedCustomers.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={ALL_CUSTOMER_COLUMNS.filter(c => visibleColumns.has(c.id)).length} align="center" sx={{ py:8, borderBottom:"none", background:"transparent" }}>
                        <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", gap:2 }}>
                          <Box sx={{ width:64, height:64, borderRadius:"50%", backgroundColor:"var(--ec-color-surface-muted)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                            <FolderOffIcon sx={{ fontSize:32, color:"var(--ec-color-text-muted)" }} />
                          </Box>
                          <Box sx={{ textAlign:"center" }}>
                            <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>No {pageLabel.toLowerCase()} found</Typography>
                            <Typography variant="body2" color="text.disabled" sx={{ maxWidth:340 }}>
                              {hasActiveFilters ? "No records match your current search." : `You don't have any records yet.`}
                            </Typography>
                          </Box>
                          <Stack direction="row" spacing={1.5} mt={0.5}>
                            {hasActiveFilters && (
                              <Button variant="outlined" size="small" startIcon={<ClearIcon />} onClick={handleClearFilters} sx={{ textTransform:"none", fontWeight:600 }}>
                                Clear Filters
                              </Button>
                            )}
                            <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={() => setShowCustomerModal(true)} sx={{ textTransform:"none", fontWeight:700 }}>
                              {customerTab === "myLeads" ? "New Lead" : "New Customer"}
                            </Button>
                          </Stack>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                
                  {!loading && sortedCustomers.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      hover
                      onClick={() => handleRowClick(row)}
                      sx={{ cursor:"pointer", backgroundColor: C.paperBg, transition:"background-color 0.1s", "&:hover":{ backgroundColor: C.subtleBg } }}
                    >
                      {ALL_CUSTOMER_COLUMNS.filter(c => visibleColumns.has(c.id)).map(col => {
                        const stopClick = col.id === "actions" ? { onClick: e => e.stopPropagation() } : {};
                        return (
                          <TableCell
                            key={col.id}
                            align={col.align || "left"}
                            sx={{ px:2, py: currentDensity.py, fontSize: currentDensity.fontSize, color: C.textPri, verticalAlign:"middle" }}
                            {...stopClick}
                          >
                            {renderCell(col, row, index)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

       
            <Box sx={{ px:2, py:0, backgroundColor: C.paperBg, borderTop:`1px solid ${C.border}`, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"space-between", minHeight:52 }}>
              <Typography variant="body2" sx={{ color:"var(--ec-color-text-muted)", fontSize:"0.8125rem", pl:1 }}>
                {total > 0
                  ? `Showing ${(currentPage-1)*rowsPerPage+1}–${Math.min(currentPage*rowsPerPage, total)} of ${total} record${total !== 1 ? "s" : ""}`
                  : loading ? "" : "No results"}
              </Typography>

              <TablePagination
                component="div"
                count={total}
                page={currentPage - 1}
                onPageChange={(_, newPage) => {
                  if (pageGuard.current.suppress) { pageGuard.current.suppress = false; return; }
                  const safe = Math.max(1, Math.min(newPage + 1, totalPages || 1));
                  if (safe === currentPage) return;
                  gotoPage(safe);
                }}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={e => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  const p = new URLSearchParams(location.search);
                  p.set("tab", customerTab);
                  p.set("page", "1");
                  navigate(p);
                }}
                rowsPerPageOptions={[12, 25, 50]}
                sx={{
                  border:0,
                  "& .MuiTablePagination-toolbar":{ minHeight:52, px:0, alignItems:"center" },
                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":{ fontSize:"0.8125rem", color:"var(--ec-color-text-muted) !important", mb:0, lineHeight:1 },
                  "& .MuiTablePagination-select":{ fontSize:"0.8125rem" },
                }}
              />
            </Box>
          </UITableShell>
        </Box>
      </div>
 
      {showCustomerModal && (
        <CustomerModal
          open={showCustomerModal}
          onClose={() => setShowCustomerModal(false)}
          onCustomerCreated={handleNewCustomerCreated}
          viewScreen={pageLabel}
          existingCustomers={customers}
        />
      )}

      {showDetailModal && selectedCustomer && (
        <CustomerDetailModal
          open={showDetailModal}
          onClose={() => setShowDetailModal(false)}
          customer={selectedCustomer}
          onCustomerUpdated={handleCustomerUpdated}
          viewScreen={pageLabel}
        />
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical:"bottom", horizontal:"right" }}
      >
        <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width:"100%", fontWeight:600 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InstanceCustomers;



// -------------------------------------------------------------------
// CustomerModal Component – For Creating a New Customer
// -------------------------------------------------------------------
const CustomerModal = ({
  open,
  onClose,
  onCustomerCreated,
  viewScreen,
  existingCustomers = [],
}) => {
  const { id: instanceId } = useParams();
  const { authState } = useContext(AuthContext);
  const [AssignedTo, setAssignedTo] = useState([]);
  const [assignedError, setAssignedError] = useState(false);
  const [submitError, setSubmitError] = useState("");

  // Default status based on where the modal was opened
  const isLeadViewDefault = viewScreen === "My Leads"; // simplified for new tabs
  const normalizedUserRole = String(authState?.role || "")
    .trim()
    .replace(/_/g, "-")
    .toLowerCase();
  const restrictedToLead = [
    "order-rep",
    "client-rep",
    "demo-user",
  ].includes(normalizedUserRole);
  const defaultStatus = restrictedToLead
    ? "lead"
    : isLeadViewDefault
      ? "lead"
      : "Active";

  const initialValues = {
    businessName: "",
    emailAddress: "",
    phoneNumber: "",
    clientContacts: [
      { firstName: "", lastName: "", email: "", phone: "", title: "" },
    ],
    status: defaultStatus,
  };

  const validationSchema = Yup.object({
    businessName: Yup.string().required("Customer Name is required"),
    emailAddress: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
    phoneNumber: Yup.string().required("Phone is required"),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitError("");
    if (AssignedTo.length === 0) {
      setAssignedError(true);
      setSubmitting(false);
      return;
    }

    const payload = {
      instanceId,
      businessName: values.businessName,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
      AssignedTo,
      status: restrictedToLead ? "lead" : values.status,
      clientContacts: values.clientContacts,
      instanceUniqueIds: ["elite-promo-marketing"],
    };

    axios
      .post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/create-customer`,
        payload,
        { headers: { Authorization: `Bearer ${authState.token}` } },
      )
      .then((response) => {
        const newCustomer = response.data.customer || {
          ...payload,
          id: Date.now(),
        };
        onCustomerCreated(newCustomer);
        resetForm();
        onClose();
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("Error creating customer", error);
        const message =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Unable to create record. Please try again.";
        setSubmitError(message);
        setSubmitting(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="create-new create-order-dialog manage-account-dialog"
    >
      <Formik
        initialValues={initialValues}
        enableReinitialize // ← important when opening from different tabs
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors, touched, isSubmitting }) => {
          const effectiveStatus = restrictedToLead ? "lead" : values.status;
          const isLead = effectiveStatus === "lead";
          const entityLabel = isLead ? "Lead" : "Customer";
          const entityLower = isLead ? "lead" : "customer";

          return (
            <>
              {/* Title now reacts to status */}
              <DialogTitle className="create-order-dialog-title">
                Create New {entityLabel}
              </DialogTitle>

              <DialogContent className="create-order-dialog-content">
                <Form className="create-order-form">
                  {submitError ? (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {submitError}
                    </Alert>
                  ) : null}
                  <CustomerDuplicateSuggestions
                    instanceUniqueId={instanceId}
                    businessName={values.businessName}
                    emailAddress={values.emailAddress}
                    phoneNumber={values.phoneNumber}
                    enabled={isLead}
                  />
                  {!restrictedToLead ? (
                    <Box mb={2}>
                      <FormControl
                        component="fieldset"
                        error={touched.status && Boolean(errors.status)}
                      >
                        <FormLabel component="legend">Status</FormLabel>
                        <ToggleButtonGroup
                          value={values.status}
                          exclusive
                          onChange={(_, newStatus) => {
                            if (newStatus) setFieldValue("status", newStatus);
                          }}
                          aria-label="customer status"
                        >
                          <ToggleButton value="lead" aria-label="lead">
                            <WhatshotIcon sx={{ mr: 1 }} /> Lead
                          </ToggleButton>
                          <ToggleButton value="Active" aria-label="customer">
                            <GroupIcon sx={{ mr: 1 }} /> Customer
                          </ToggleButton>
                        </ToggleButtonGroup>
                        <FormHelperText>
                          <ErrorMessage name="status" />
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  ) : null}

                  <Box mb={2}>
                    <Field
                      as={TextField}
                      label="Business/individual's name"
                      name="businessName"
                      className="create-order-input"
                      fullWidth
                      placeholder="Business/individual's name"
                      helperText={<ErrorMessage name="businessName" />}
                    />
                  </Box>

                  <Box mb={2}>
                    <Field
                      as={TextField}
                      label="Main contact email"
                      name="emailAddress"
                      className="create-order-input"
                      fullWidth
                      helperText={<ErrorMessage name="emailAddress" />}
                    />
                  </Box>

                  <Box mb={2}>
                    <Field
                      as={TextField}
                      label="Main contact phone"
                      name="phoneNumber"
                      className="create-order-input"
                      fullWidth
                      helperText={<ErrorMessage name="phoneNumber" />}
                    />
                  </Box>

                  <Typography sx={{ fontSize: "1rem", fontWeight: 700, mb: 2 }}>
                    Users or teams added to this {entityLower} will be
                    automatically added to all future orders.
                  </Typography>

                  <OrderUserAssignment
                    initialAssignedUsers={AssignedTo}
                    onChangeAssignedUsers={(newAssigned) => {
                      setAssignedTo(newAssigned);
                      if (newAssigned.length > 0) setAssignedError(false);
                    }}
                  />

                  {assignedError && (
                    <FormHelperText error>
                      You must assign at least one user
                    </FormHelperText>
                  )}

                  <ErrorMessage name="AssignedTo" component="span" />

                  <Box mb={2} sx={{ pt: "30px" }}>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 700, mb: 2 }}>
                      Contacts within {entityLabel}{" "}
                      {values.businessName ||
                        `[Please insert a ${entityLower} contact]`}
                    </Typography>
                    <FieldArray name="clientContacts">
                      {({ remove, push, form: arrayForm }) => (
                        <div className="client-contact-container">
                          {arrayForm.values.clientContacts.map(
                            (contact, index) => (
                              <Box key={index} mb={2} p={2}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      as={TextField}
                                      label="First Name"
                                      name={`clientContacts.${index}.firstName`}
                                      className="create-order-input"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      as={TextField}
                                      label="Last Name"
                                      name={`clientContacts.${index}.lastName`}
                                      className="create-order-input"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      as={TextField}
                                      label="Email"
                                      name={`clientContacts.${index}.email`}
                                      className="create-order-input"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      as={TextField}
                                      label="Phone"
                                      name={`clientContacts.${index}.phone`}
                                      className="create-order-input"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Field
                                      as={TextField}
                                      label="Title"
                                      name={`clientContacts.${index}.title`}
                                      className="create-order-input"
                                      fullWidth
                                    />
                                  </Grid>
                                </Grid>
                                <Box
                                  mt={1}
                                  display="flex"
                                  justifyContent="flex-end"
                                >
                                  {arrayForm.values.clientContacts.length >
                                    1 && (
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      onClick={() => remove(index)}
                                      className="remove-contact-button"
                                      style={{ marginRight: 8 }}
                                    >
                                      Remove
                                    </Button>
                                  )}
                                  {index ===
                                    arrayForm.values.clientContacts.length -
                                      1 && (
                                    <Button
                                      variant="outlined"
                                      onClick={() =>
                                        push({
                                          firstName: "",
                                          lastName: "",
                                          email: "",
                                          phone: "",
                                          title: "",
                                        })
                                      }
                                      className="add-contact-button MuiButton-textSecondary"
                                    >
                                      Add More
                                    </Button>
                                  )}
                                </Box>
                              </Box>
                            ),
                          )}
                        </div>
                      )}
                    </FieldArray>
                  </Box>

                  {/* Actions now react to status */}
                  <DialogActions className="create-customer-dialog-actions">
                    <Button onClick={onClose} color="secondary">
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      Create {entityLabel}
                    </Button>
                  </DialogActions>
                </Form>
              </DialogContent>
            </>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export { CustomerModal };

// -------------------------------------------------------------------
// CustomerDetailModal Component – For Editing Customer Details with Tabs & Assigned Users
// -------------------------------------------------------------------
const CustomerDetailModal = ({
  open,
  onClose,
  customer,
  onCustomerUpdated,
  viewScreen,
}) => {
  const { authState } = useContext(AuthContext);
  const theme = useTheme();
  const history = useHistory();
  const { instanceUniqueId } = useParams();
  const {
    getWorkflowLabel,
    getWorkflowTooltip,
    loading: workflowSettingsLoading,
  } = useWorkflowDisplaySettings(instanceUniqueId);
  const [activeTab, setActiveTab] = useState("edit");
  const [orders, setOrders] = useState([]);
  const [AssignedTos, setAssignedUsers] = useState(customer.AssignedTo || []);
  const defaultLogo = "/elite-core-brand-logo.png";
  const [logoPreview, setLogoPreview] = useState(defaultLogo);
  const [logoFile, setLogoFile] = useState(null);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [emailTo, setEmailTo] = useState("");
  const [emailCc, setEmailCc] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [savingAssignedUsers, setSavingAssignedUsers] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [taxOptions, setTaxOptions] = useState([]);
  const [termsOptions, setTermsOptions] = useState([]);
  const [instanceDefaultTermsId, setInstanceDefaultTermsId] = useState(null);
  const [instanceDefaultTaxId, setInstanceDefaultTaxId] = useState(null);
  const [instanceTermsDefaultLoading, setInstanceTermsDefaultLoading] = useState(false);
  const [instanceTermsDefaultError, setInstanceTermsDefaultError] = useState(false);
  const [fullCustomer, setFullCustomer] = useState(customer);
  const [portalSettings, setPortalSettings] = useState({
    publicSlug: customer?.publicSlug || "",
    publicVisibility: "private",
  });
  const [savingPortalSettings, setSavingPortalSettings] = useState(false);
  const [invitingContactId, setInvitingContactId] = useState(null);
  const [overviewSubmitErrors, setOverviewSubmitErrors] = useState([]);
  const [shippingAccounts, setShippingAccounts] = useState([]);
  const [shippingAccountsLoading, setShippingAccountsLoading] = useState(false);
  const [shippingAccountModalOpen, setShippingAccountModalOpen] = useState(
    false,
  );
  const [qboDialogOpen, setQboDialogOpen] = useState(false);
  const [disconnectingQbo, setDisconnectingQbo] = useState(false);
  const [historySearch, setHistorySearch] = useState("");
  const [historyPage, setHistoryPage] = useState(0);
  const [googlePlacesConfig, setGooglePlacesConfig] = useState(null);
  const HISTORY_ROWS_PER_PAGE = 8;

  useEffect(() => {
    setPortalSettings({
      publicSlug: fullCustomer?.publicSlug || "",
      publicVisibility: "private",
    });
  }, [fullCustomer?.publicSlug, fullCustomer?.publicVisibility]);

  const customerPageUrl = portalSettings.publicSlug
    ? `${window.location.origin}/customer/${portalSettings.publicSlug}`
    : "";

  const savePortalSettings = async () => {
    if (savingPortalSettings) return;
    setSavingPortalSettings(true);
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}/portal-settings`,
        portalSettings,
        { headers: { accessToken: localStorage.getItem("accessToken") } },
      );
      setFullCustomer((current) => ({ ...current, ...data }));
      setPortalSettings(data);
      onCustomerUpdated({ ...customer, ...data });
      toast.success("Customer page settings saved.");
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Unable to save customer page settings."));
    } finally {
      setSavingPortalSettings(false);
    }
  };

  const invitePortalContact = async (contact) => {
    const contactId = contact?.contactId || contact?.id;
    if (!contactId || invitingContactId) return null;
    setInvitingContactId(contactId);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}/client-contacts/${encodeURIComponent(contactId)}/invite`,
        {},
        { headers: { accessToken: localStorage.getItem("accessToken") } },
      );
      const updatedContact = {
        ...contact,
        ...data.contact,
        portalAccountStatus: data.account?.status || "active",
      };
      setFullCustomer((current) => ({
        ...current,
        clientContacts: (current?.clientContacts || []).map((item) =>
          String(item.contactId || item.id) === String(contactId) ? updatedContact : item),
      }));
      toast.success(data.created ? "Customer account invitation sent." : "Customer account is already linked.");
      return updatedContact;
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Unable to invite this contact."));
      return null;
    } finally {
      setInvitingContactId(null);
    }
  };
  const historyDensity = { py: 1.5, fontSize: "0.875rem" };
  const historyTableColors = {
    paperBg: theme.palette.background.paper,
    subtleBg: theme.palette.action.hover,
    border: theme.palette.divider,
    textPri: theme.palette.text.primary,
    textMuted: theme.palette.text.disabled,
  };

  const projectHistoryRows = useMemo(() => {
    const start = historyPage * HISTORY_ROWS_PER_PAGE;
    return orders.slice(start, start + HISTORY_ROWS_PER_PAGE);
  }, [orders, historyPage]);

  useEffect(() => {
    setHistoryPage(0);
  }, [orders.length]);

  useEffect(() => {
    let cancelled = false;

    if (activeTab !== "addresses" || !instanceUniqueId) {
      setGooglePlacesConfig(null);
      return undefined;
    }

    getGooglePlacesBrowserConfig(instanceUniqueId)
      .then((payload) => {
        if (cancelled) return;
        setGooglePlacesConfig(payload?.googlePlaces || null);
      })
      .catch(() => {
        if (cancelled) return;
        setGooglePlacesConfig(null);
      });

    return () => {
      cancelled = true;
    };
  }, [activeTab, instanceUniqueId]);

  const roleNormalized = String(authState?.role || "")
    .replace(/_/g, "-")
    .toLowerCase();
  const canManageQboConnections =
    ["administrator", "super-administrator"].includes(roleNormalized) || roleNormalized === "finance-rep";
  const canArchiveCustomers = ["administrator", "super-administrator"].includes(roleNormalized);
  const canRepairCustomerContacts = roleNormalized === "administrator";
  const isArchivedCustomer =
    String(fullCustomer?.status || customer?.status || "").trim().toLowerCase() === "archived";
  const [archivingCustomer, setArchivingCustomer] = useState(false);
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);
  const [archiveNote, setArchiveNote] = useState("");
  const [contactRepairOpen, setContactRepairOpen] = useState(false);
  const [mergeDialogOpen, setMergeDialogOpen] = useState(false);
  const [mergeTargetId, setMergeTargetId] = useState("");
  const [mergePreviewError, setMergePreviewError] = useState("");
  const [mergePreview, setMergePreview] = useState(null);
  const [mergePreviewLoading, setMergePreviewLoading] = useState(false);
  const [mergeSaving, setMergeSaving] = useState(false);
  const [mergeSearch, setMergeSearch] = useState("");
  const [mergeCandidates, setMergeCandidates] = useState([]);
  // Merge search uses a separate endpoint from the customer directory. Normalize its
  // name fields before passing records to MUI Autocomplete.
  const mergeCustomerLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;
    const name = [option.businessName, option.name, option.companyName,
      [option.firstName, option.lastName].filter(Boolean).join(" ")]
      .find((value) => typeof value === "string" && value.trim());
    return `${name ? name.trim() : "Customer"} (#${option.id})`;
  };

  const [mergeSelectedCustomer, setMergeSelectedCustomer] = useState(null);
  const [mergeSearchLoading, setMergeSearchLoading] = useState(false);
  // The existing server preview and commit paths enforce merge safety.
  useEffect(() => {
    if (!mergeDialogOpen || !instanceUniqueId) return undefined;
    let cancelled = false;
    const timeout = setTimeout(async () => {
      setMergeSearchLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/api/instances/${instanceUniqueId}/tools/customer-merge/candidates`,
          { params: { q: mergeSearch.trim(), excludeCustomerId: customer?.id }, headers: { accessToken: localStorage.getItem("accessToken") } }
        );
        if (!cancelled) {
          setMergeCandidates((Array.isArray(data.customers) ? data.customers : []).filter((option) => option?.id != null && String(option.id) !== String(customer?.id)));
          setMergePreviewError("");
        }
      } catch (error) {
        if (!cancelled) {
          setMergeCandidates([]);
          setMergePreviewError(error?.response?.data?.error || error?.message || "Unable to search customers.");
        }
      } finally {
        if (!cancelled) setMergeSearchLoading(false);
      }
    }, mergeSearch.trim() ? 300 : 0);
    return () => { cancelled = true; clearTimeout(timeout); };
  }, [mergeDialogOpen, mergeSearch, instanceUniqueId, customer?.id]);
  const openMergeDialog = () => {
    setMergeTargetId("");
    setMergeSelectedCustomer(null);
    setMergeSearch("");
    setMergeCandidates([]);
    setMergePreviewError("");
    setMergePreview(null);
    setMergeDialogOpen(true);
  };


  const openArchiveDialog = () => {
    if (!canArchiveCustomers || isArchivedCustomer || archivingCustomer) return;
    setArchiveNote("");
    setArchiveDialogOpen(true);
  };

  const archiveCustomer = async () => {
    if (!canArchiveCustomers || isArchivedCustomer || archivingCustomer) return;

    setArchivingCustomer(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}/archive`,
        { note: archiveNote.trim() || null },
        { headers: { accessToken: localStorage.getItem("accessToken") } },
      );
      const archivedCustomer = data?.customer || {
        ...fullCustomer,
        status: "archived",
      };
      setFullCustomer(archivedCustomer);
      onCustomerUpdated(archivedCustomer);
      toast.success("Customer archived.");
      setArchiveDialogOpen(false);
      setArchiveNote("");
      if (viewScreen !== "All Accounts") onClose();
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Unable to archive customer."));
    } finally {
      setArchivingCustomer(false);
    }
  };

  const archiveAuditEntry = useMemo(() => {
    const notes = Array.isArray(fullCustomer?.customerNotes)
      ? fullCustomer.customerNotes
      : [];
    return [...notes]
      .filter((note) => note?.action === "archive-customer")
      .sort(
        (a, b) =>
          new Date(b?.archivedAt || b?.timestamp || 0) -
          new Date(a?.archivedAt || a?.timestamp || 0),
      )[0] || null;
  }, [fullCustomer?.customerNotes]);

  const archiveActorName =
    archiveAuditEntry?.userName ||
    archiveAuditEntry?.userEmail ||
    (archiveAuditEntry?.userId ? `User #${archiveAuditEntry.userId}` : "Administrator");
  const archiveTimestamp =
    archiveAuditEntry?.archivedAt || archiveAuditEntry?.timestamp || null;

  const historyRows = useMemo(() => {
    const notes = Array.isArray(fullCustomer?.customerNotes)
      ? fullCustomer.customerNotes
      : [];
    const displayNotes = notes.map((note, index) => {
      if (note?.type !== "customer_import_merge") return note;
      const additions = (note.changes || []).map((change) => {
        if (change.type === "field") return change.field === "phoneNumber" ? "Phone" : String(change.field || "Field").replace(/([A-Z])/g, " $1").trim();
        if (change.type === "contact") return `${change.label || "Contact"} contact`;
        if (change.type === "address") return `${change.label || "Address"} address`;
        return change.label || "Representative";
      });
      return {
        ...note,
        sequence: note.sequence || `import-${index + 1}`,
        timestamp: note.createdAt,
        action: "Customer import merged data",
        message: [`Added:`, ...additions.map((label) => `• ${label}`), "Existing populated values were preserved."].join("\n"),
        userId: note.createdByUserId,
      };
    });
    return [...displayNotes].sort(
      (a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0),
    );
  }, [fullCustomer?.customerNotes]);

  const filteredHistoryRows = useMemo(() => {
    const q = String(historySearch || "")
      .trim()
      .toLowerCase();
    if (!q) return historyRows;
    return historyRows.filter((note) => {
      const haystack = [
        note?.message,
        note?.action,
        note?.userName,
        note?.userEmail,
        note?.userRole,
        note?.userId,
        note?.orderId,
      ]
        .map((v) => String(v || "").toLowerCase())
        .join(" ");
      return haystack.includes(q);
    });
  }, [historyRows, historySearch]);

  const paginatedHistoryRows = useMemo(() => {
    const start = historyPage * HISTORY_ROWS_PER_PAGE;
    return filteredHistoryRows.slice(start, start + HISTORY_ROWS_PER_PAGE);
  }, [filteredHistoryRows, historyPage]);

  useEffect(() => {
    setHistoryPage(0);
  }, [historySearch, customer?.id]);

  useEffect(() => {
    const maxPage = Math.max(
      0,
      Math.ceil(filteredHistoryRows.length / HISTORY_ROWS_PER_PAGE) - 1,
    );
    if (historyPage > maxPage) {
      setHistoryPage(maxPage);
    }
  }, [filteredHistoryRows.length, historyPage]);

  useEffect(() => {
    (async () => {
      try {
        const [taxRes, termsRes] = await Promise.all([getTaxes(), getTerms()]);
        setTaxOptions(taxRes.taxes || []);
        setTermsOptions(termsRes.terms || []);
      } catch (err) {
        console.error("Failed to load tax or terms options", err);
      }
    })();
  }, []);

  // Customer terms may be empty while the instance's default Terms ID is active.
  // Fetch the actual Company Defaults setting; never use the first dropdown option.
  useEffect(() => {
    if (!open || !instanceUniqueId) return;
    let cancelled = false;
    setInstanceDefaultTermsId(null);
    setInstanceDefaultTaxId(null);
    setInstanceTermsDefaultError(false);
    setInstanceTermsDefaultLoading(true);
    fetchInstanceDefaultsByUniqueId(instanceUniqueId)
      .then(({ defaults }) => {
        if (!cancelled) {
          setInstanceDefaultTermsId(defaults?.defaultTermsId ?? null);
          setInstanceDefaultTaxId(defaults?.defaultTaxId ?? null);
        }
      })
      .catch(() => {
        if (!cancelled) setInstanceTermsDefaultError(true);
      })
      .finally(() => {
        if (!cancelled) setInstanceTermsDefaultLoading(false);
      });
    return () => { cancelled = true; };
  }, [open, instanceUniqueId]);

  const refreshCustomerDetail = useCallback(async () => {
    if (!customer?.id) return null;
    try {
      const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}`,
          {
            params: { accessContext: "customer-directory", instanceUniqueId },
            headers: { accessToken: localStorage.getItem("accessToken") },
          },
      );
      const hydrated = normalizeCustomerForModal(data.customer || data);
      setFullCustomer(hydrated);
      return hydrated;
    } catch (err) {
      console.error("Failed to hydrate customer for modal", err);
      throw err;
    }
  }, [customer?.id, instanceUniqueId]);

  useEffect(() => {
    if (!open || !customer?.id) return;
    refreshCustomerDetail().catch(() => {});
  }, [open, customer?.id, refreshCustomerDetail]);

  const loadShippingAccounts = useCallback(async () => {
    if (!fullCustomer?.id) return;
    setShippingAccountsLoading(true);
    try {
      const response = await getAllClientAccounts({
        instanceUniqueId,
        customerId: fullCustomer.id,
      });
      setShippingAccounts(response?.data || []);
    } catch (error) {
      console.error("Failed to load shipping accounts", error);
      setShippingAccounts([]);
    } finally {
      setShippingAccountsLoading(false);
    }
  }, [fullCustomer?.id, instanceUniqueId]);

  useEffect(() => {
    if (activeTab !== "shipping-accounts") return;
    loadShippingAccounts();
  }, [activeTab, loadShippingAccounts]);

  useEffect(() => {
    if (activeTab === "quickbooks-connection" && !canManageQboConnections) {
      setActiveTab("edit");
    }
  }, [activeTab, canManageQboConnections]);

  const handleDisconnectQbo = async () => {
    if (!fullCustomer?.id || disconnectingQbo) return;
    if (!window.confirm("Disconnect this customer from QuickBooks?")) return;

    setDisconnectingQbo(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/invoices/customers/${fullCustomer.id}/qbo/link`,
        { headers: { accessToken: localStorage.getItem("accessToken") } },
      );

      setFullCustomer((prev) => ({
        ...prev,
        qbo_ref_id: null,
        qboRefId: null,
        qboCustomerId: null,
        qbo_link_status: "unmapped",
        accountingRef: null,
      }));
      toast.success("QuickBooks customer disconnected.");
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          "Failed to disconnect QuickBooks customer.",
      );
    } finally {
      setDisconnectingQbo(false);
    }
  };

  const togglePanel = (panel) => {
    setExpanded((prev) => (prev === panel ? false : panel));
  };

  const { role: userRole } = authState;
  const isLead = customer.status === "lead" || customer.status === "in-review";

  // Who may edit core customer fields:
  const canEditCore = canEditCoreCustomerFields(userRole);
  const canEditContact = canEditCustomerContactFields(userRole);

  // Who may touch assigned users:
  const canEditAssignment = canEditCustomerAssignments(userRole);

  const currencyOptions = [
    { id: "USD", label: "USD" },
    { id: "CAD", label: "CAD" },
  ];

  // Update logo preview on customer change
  useEffect(() => {
    if (customer && customer.customUploadedBrandLogo) {
      setLogoPreview(customer.customUploadedBrandLogo);
    } else {
      setLogoPreview(defaultLogo);
    }
  }, [customer]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setLogoPreview(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogoSubmit = () => {
    if (!logoFile) {
      toast.error("Please select a logo file first.");
      return;
    }
    const data = new FormData();
    data.append("customUploadedBrandLogo", logoFile);
    data.append("customerId", customer.id);

    axios
      .post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/update-customer-logo/${customer.id}`,
        data,
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        },
      )
      .then((response) => {
        onCustomerUpdated(response.data.customer);
        toast.success("Your brand logo has been successfully updated.");
      })
      .catch((error) => {
        console.error("Error uploading logo", error);
        toast.error(
          getApiErrorMessage(
            error,
            "There was an error uploading the logo.",
          ),
        );
      });
  };

  // Update assigned users when customer changes
  useEffect(() => {
    setAssignedUsers(customer.AssignedTo || []);
  }, [customer]);

  // Fetch orders (Projects tab)
  useEffect(() => {
    if (customer && customer.id) {
      axios
        .get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/by-customer/${customer.id}`,
          {
            headers: {
              accessToken: localStorage.getItem("accessToken"),
            },
          },
        )
        .then((response) => setOrders(response.data.orders))
        .catch((error) => console.error("Error fetching orders", error));
    }
  }, [customer, authState.token]);

  const resolveTaxSelectValue = (rawDefaultTax) => {
    if (rawDefaultTax == null || String(rawDefaultTax).trim() === "") {
      return "";
    }

    const numericDefaultTax = Number(rawDefaultTax);
    if (!Number.isFinite(numericDefaultTax)) {
      return "";
    }

    const taxById = taxOptions.find(
      (tax) => Number(tax.id) === numericDefaultTax,
    );
    if (taxById) return taxById.id;

    const taxByRate = taxOptions.find((tax) => {
      const rate = tax.rate ?? tax.value;
      return rate != null && Number(rate) === numericDefaultTax;
    });

    return taxByRate?.id ?? "";
  };
  // Do not present the first configured term as a saved customer term.
  // Empty customer terms may still resolve through instance defaults downstream.
  const storedCustomerTermId = fullCustomer?.terms != null && String(fullCustomer.terms).trim() !== ""
    ? Number(fullCustomer.terms)
    : "";

  const effectiveDefaultTerm = instanceDefaultTermsId == null
    ? null
    : termsOptions.find((term) => String(term.id) === String(instanceDefaultTermsId));
  const effectiveDefaultTermLabel = effectiveDefaultTerm?.name
    || (instanceDefaultTermsId != null ? `Terms ID #${instanceDefaultTermsId}` : null);

  // Show the actual inherited Terms ID when no customer-specific term is saved.
  // This is display-only until someone explicitly chooses a different option.
  const displayedCustomerTermId = storedCustomerTermId !== ""
    ? storedCustomerTermId
    : instanceDefaultTermsId != null && String(instanceDefaultTermsId).trim() !== ""
      ? Number(instanceDefaultTermsId)
      : "";

  // Overview Form values and validation (Tab 0)
  const overviewInitialValues = {
    businessName: fullCustomer?.businessName || fullCustomer?.name || "",
    emailAddress: fullCustomer?.emailAddress || fullCustomer?.email || "",
    phoneNumber: fullCustomer?.phoneNumber || fullCustomer?.phone || "",
    salesBudget: fullCustomer?.salesBudget || "",
    AssignedTo: fullCustomer?.AssignedTo || [],
    defaultTax: resolveTaxSelectValue(fullCustomer?.defaultTax) || resolveTaxSelectValue(instanceDefaultTaxId),
    terms: displayedCustomerTermId,
    defaultCurrency: fullCustomer?.defaultCurrency || "CAD",
    industry: Array.isArray(fullCustomer?.industry)
      ? fullCustomer.industry
      : [],
  };

  const handleOverviewSubmit = (values, actions) => {
    setOverviewSubmitErrors([]);
    const payload = canEditCore ? {
      id: customer.id,
      businessName: values.businessName,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
      AssignedTo: values.AssignedTo,
      // Inherited company tax is display-only until explicitly changed.
      ...(String(values.defaultTax ?? "") !== String(overviewInitialValues.defaultTax ?? "")
        ? { defaultTax: values.defaultTax || null }
        : {}),
      // Do not save an inherited Company Default into Customer.terms simply
      // because the user saved another overview field.
      // Only persist terms if the selected ID differs from what was displayed.
      ...(String(values.terms ?? "") !== String(displayedCustomerTermId)
        ? { terms: values.terms || null }
        : {}),
      defaultCurrency: values.defaultCurrency, // "USD" or "CAD"
      industry: values.industry, // array of strings
    } : {
      id: customer.id,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
    };
    axios
      .put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/update-customer/${customer.id}`,
        payload,
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        },
      )
      .then((response) => {
        setOverviewSubmitErrors([]);
        onCustomerUpdated(response.data.customer || payload);
        toast.success("Customer overview saved successfully.");
      })
      .catch((error) => {
        console.error("Error updating overview", error);
        const messages = getOverviewSaveErrors(error);
        setOverviewSubmitErrors(messages);
        toast.error(messages[0]);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  // Addresses Form values and validation (Tab 1)
  // Addresses Form values (Tab 1)
  const blankAddress = {
    id: undefined, // <— keep the slot
    addressName: "", // <— optional display label
    addressType: "both",
    street: "",
    suiteApt: "",
    city: "",
    state: "",
    postal: "",
    country: "Canada",
  };

const addressesInitialValues = {
  addresses: (() => {
    const sourceAddresses =
      (Array.isArray(fullCustomer?.addresses) && fullCustomer.addresses) ||
      (Array.isArray(fullCustomer?.address) && fullCustomer.address) ||
      (Array.isArray(customer?.addresses) && customer.addresses) ||
      (Array.isArray(customer?.address) && customer.address) ||
      [];

    if (sourceAddresses.length === 0) return [blankAddress];

    return sourceAddresses.map(a => ({
        id:            Number.isInteger(a?.id) ? a.id : undefined,
        addressName:   a?.addressName || "",
        addressType:  normalizeCustomerAddressType(a?.addressType),
        street:        a?.street || a?.streetAddress || "",
        suiteApt:      a?.suiteApt || "",
        city:          a?.city || "",
        state:         a?.state || a?.stateProvince || "",
        postal:        a?.postal || a?.postalZipCode || "",
        country:       normalizeCustomerAddressCountry(a?.country) || "Canada",
      }));
  })(),
};
  const handleAddressesSubmit = (values, actions) => {
    const payload = {
      id: customer.id,
      addresses: values.addresses,
      address: values.addresses,
    };
    axios
      .put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/update-customer/${customer.id}`,
        payload,
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        },
      )
      .then((response) => {
        const updatedCustomer = response.data.customer || payload;
        setFullCustomer((prev) =>
          normalizeCustomerForModal({ ...prev, ...updatedCustomer }),
        );
        onCustomerUpdated(updatedCustomer);
        toast.success("Addresses saved successfully.");
      })
      .catch((error) => {
        console.error("Error updating addresses", error);
        if (error?.response?.data?.code === "ADDRESS_VALIDATION_FAILED") {
          actions.setErrors(
            mapAddressErrorsToFormik(error.response?.data?.errors || {}),
          );
          actions.setTouched(
            mapAddressTouchedToFormik(error.response?.data?.errors || {}),
          );
        }
        toast.error(
          getApiErrorMessage(
            error,
            "Failed to save addresses. Please try again.",
          ),
        );
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  // Contacts Form values and submission (Tab 3)
  const getInitialClientContacts = () => {
    if (
      Array.isArray(fullCustomer?.clientContacts) &&
      fullCustomer.clientContacts.length > 0
    ) {
      return fullCustomer.clientContacts.map(normalizeEditableClientContact);
    }

    if (
      Array.isArray(customer?.clientContacts) &&
      customer.clientContacts.length > 0
    ) {
      return customer.clientContacts.map(normalizeEditableClientContact);
    }

    return [normalizeEditableClientContact()];
  };

  const contactsInitialValues = {
    clientContacts: getInitialClientContacts(),
  };
  // Send the snapshot shown when this form opened. The server verifies it
  // under the customer row lock, including after a source-email recovery.
  // Use the saved list (not the empty-form placeholder) for new customers.
  const contactsBeforeEdit = Array.isArray(fullCustomer?.clientContacts)
    ? fullCustomer.clientContacts : Array.isArray(customer?.clientContacts)
      ? customer.clientContacts : [];

  const handleContactsSubmit = (values, actions) => {
    const payload = {
      id: customer.id,
      clientContacts: values.clientContacts,
      clientContactsBeforeEdit: contactsBeforeEdit,
    };
    axios
      .put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/update-customer/${customer.id}`,
        payload,
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        },
      )
      .then((response) => {
        const updatedCustomer = response.data.customer || payload;
        setFullCustomer((prev) => normalizeCustomerForModal({ ...prev, ...updatedCustomer }));
        onCustomerUpdated(updatedCustomer);
        toast.success("Contacts saved successfully.");
      })
      .catch((error) => {
        console.error("Error updating contacts", error);
        toast.error(
          getApiErrorMessage(
            error,
            "Failed to save contacts. Please try again.",
          ),
        );
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  // Assigned Users handler (Tab 4)
  const handleAssignedUsersSubmit = () => {
    if (savingAssignedUsers) return;

    const payload = { AssignedTo: AssignedTos };
    setSavingAssignedUsers(true);
    axios
      .put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/update-customer/${customer.id}`,
        payload,
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        },
      )
      .then((response) => {
        onCustomerUpdated(
          response.data.customer || { ...customer, AssignedTo: AssignedTos },
        );
        toast.success("Assigned users saved successfully.");
      })
      .catch((error) => {
        console.error("Error updating assigned users", error);
        toast.error(
          getApiErrorMessage(
            error,
            "Failed to save assigned users. Please try again.",
          ),
        );
      })
      .finally(() => {
        setSavingAssignedUsers(false);
      });
  };

  const isInReview = customer.status === "in-review";
  const isAnalyst = authState.role === "analytics-rep";

  const canConvertLeadToCustomer = [
    "order-rep",
    "client-rep",
    "purchasing-rep",
    "finance-rep",
    "administrator",
  ].includes(authState.role);

  let displayText = customer.status;
  let IconComponent = null;
  switch (customer.status) {
    case "lead":
      IconComponent = WhatshotIcon;
      break;
    case "in-review":
      IconComponent = HourglassFullIcon;
      displayText = "Approval requested";
      break;
    case "customer":
      IconComponent = PersonIcon;
      break;
    default:
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="create-order-dialog customer-order-dialog"
    >
      <DialogTitle className="create-order-dialog-title">
        {viewScreen} Details
      </DialogTitle>
      <DialogContent className="create-order-dialog-content customer-order-dialog-content">
        {showEmailDialog ? (
          // ——— EMAIL SCREEN ———
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Send Email
            </Typography>
            {/* To: choose from clientContacts */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="email-to-label">To</InputLabel>
              <Select
                labelId="email-to-label"
                value={emailTo}
                label="To"
                onChange={(e) => setEmailTo(e.target.value)}
              >
                {customer.clientContacts?.filter((c) => !c?.mergedIntoContactId && c?.email).map((c, i) => (
                  <MenuItem key={i} value={c.email}>
                    {c.firstName} {c.lastName} &lt;{c.email}&gt;
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* CC (optional free text) */}
            <TextField
              fullWidth
              label="CC (comma‑separated)"
              value={emailCc}
              onChange={(e) => setEmailCc(e.target.value)}
              sx={{ mb: 2 }}
            />
            {/* Subject */}
            <TextField
              fullWidth
              label="Subject"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              sx={{ mb: 2 }}
            />
            {/* Body */}
            <TextField
              fullWidth
              multiline
              minRows={4}
              label="Body"
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
              sx={{ mb: 2 }}
            />
            <DialogActions>
              <Button
                onClick={() => setShowEmailDialog(false)}
                color="secondary"
              >
                Back
              </Button>
              <Button
                onClick={async () => {
                  try {
                    await axios.post(
                      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/send-email/${customer.id}`,
                      {
                        to: emailTo,
                        cc: emailCc
                          .split(",")
                          .map((s) => s.trim())
                          .filter(Boolean),
                        subject: emailSubject,
                        body: emailBody,
                      },
                      {
                        headers: {
                          accessToken: localStorage.getItem("accessToken"),
                        },
                      },
                    );
                    toast.success("Email sent!");
                    setShowEmailDialog(false);
                  } catch (err) {
                    console.error(err);
                    toast.error(
                      getApiErrorMessage(err, "Failed to send email"),
                    );
                  }
                }}
                variant="contained"
                color="primary"
              >
                Send
              </Button>
            </DialogActions>
          </Box>
        ) : (
          <>
            {/* Upload Logo Area */}
            <Box
              className="customer-logo-container"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={getFullLogoUrl(logoPreview)}
                  alt="Brand Logo"
                  className="brand-logo-preview"
                  style={{
                    width: "80px",
                    height: "80px",
                    marginRight: "1rem",
                    objectFit: "cover",
                  }}
                />
                <div className="customer-business-name" variant="h5">
                  <div>{customer.businessName || customer.businessName}</div>
                  {IconComponent && (
                    <div className="customer-business-status">
                      <b>Status:</b> <IconComponent fontSize="small" />{" "}
                      {displayText}
                    </div>
                  )}
                </div>
              </Box>
              <Box className="customer-brand-image-btns-container">
                <input
                  name="customUploadedBrandLogo"
                  accept="image/*"
                  id="contained-button-file"
                  type="file"
                  hidden
                  onChange={handleLogoChange}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="contained"
                    component="span"
                    className="upload-logo-button"
                  >
                    Upload Logo
                  </Button>
                </label>
                <Button
                  onClick={handleLogoSubmit}
                  variant="outlined"
                  className="save-logo-button"
                  sx={{ ml: 1 }}
                >
                  Save Logo
                </Button>
              </Box>
            </Box>

            <Box className="order-progress-bar" sx={{ width: "100%", mb: 3 }}>
              {/* Chat Header Container */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  borderBottom: "1px solid #ddd",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center", // center the Chat title
                    position: "relative", // for absolute icon
                    padding: "12px 16px",
                  }}
                  className="chat-header-tab"
                  onClick={() => togglePanel("chat")}
                >
                  {/* Centered Chat Icon + Text */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ChatIcon sx={{ mr: 1 }} />
                    <Typography variant="h6">Chat</Typography>
                  </Box>

                  {/* Right Side Expand/Collapse Icon */}
                  <Box
                    sx={{
                      position: "absolute",
                      right: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    {expanded === "chat" ? <RemoveIcon /> : <AddIcon />}
                  </Box>
                </Box>
              </Box>

              {/* Expandable Chat Panel */}
              {expanded === "chat" && (
                <Box className="panel chat-panel">
                  <ChatBox
                    // assignedUsers={assignedUsers}
                    // assignedUsers={[]}
                    customerId={customer.id}
                    assignedUsers={AssignedTos}
                    // webStoreId={store.id}
                  />
                </Box>
              )}
            </Box>

            {isArchivedCustomer && (
              <Alert
                severity="info"
                icon={false}
                sx={{
                  width: "100%",
                  mb: 2,
                  boxSizing: "border-box",
                  borderRadius: 2,
                  py: 1.75,
                  px: 2,
                  "& .MuiAlert-message": {
                    width: "100%",
                    p: 0,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: 2,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                  }}
                >
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <FolderOffIcon fontSize="small" />
                      <Typography sx={{ fontWeight: 800, fontSize: "0.95rem" }}>
                        Archived customer
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", lineHeight: 1.5 }}
                    >
                      Retained for historical records only. This customer is excluded from active customer lists, imports, searches, reviews, and new projects.
                    </Typography>
                  </Box>

                  {archiveAuditEntry && (
                    <Box
                      sx={{
                        minWidth: { sm: 220 },
                        maxWidth: { md: 320 },
                        width: { xs: "100%", md: "auto" },
                        pl: { md: 2 },
                        borderLeft: { md: "1px solid" },
                        borderColor: { md: "divider" },
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "text.secondary",
                          lineHeight: 1.5,
                        }}
                      >
                        Archived by <strong>{archiveActorName}</strong>
                      </Typography>
                      {archiveTimestamp && (
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            color: "text.secondary",
                          }}
                        >
                          {new Date(archiveTimestamp).toLocaleString()}
                        </Typography>
                      )}
                      {archiveAuditEntry.archiveNote && (
                        <Box
                          sx={{
                            mt: 0.75,
                            px: 1,
                            py: 0.75,
                            borderRadius: 1,
                            bgcolor: "action.hover",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              color: "text.primary",
                              fontStyle: "italic",
                              whiteSpace: "pre-wrap",
                              lineHeight: 1.45,
                            }}
                          >
                            “{archiveAuditEntry.archiveNote}”
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Alert>
            )}

            {!isArchivedCustomer && (fullCustomer?.status === "lead" || fullCustomer?.status === "in-review") && (
              <CustomerDuplicateSuggestions
                instanceUniqueId={instanceUniqueId}
                businessName={fullCustomer?.businessName}
                emailAddress={fullCustomer?.emailAddress}
                phoneNumber={fullCustomer?.phoneNumber}
                excludeCustomerId={fullCustomer?.id}
              />
            )}
            {!isArchivedCustomer && (
              <CustomerReviewShortcut
                customer={fullCustomer}
                userRole={authState?.role}
                instanceUniqueId={instanceUniqueId}
                onRefresh={async () => {
                  const hydrated = await refreshCustomerDetail();
                  if (hydrated) onCustomerUpdated(hydrated);
                  return hydrated;
                }}
              />
            )}

            <Dialog
              open={archiveDialogOpen}
              onClose={() => {
                if (!archivingCustomer) setArchiveDialogOpen(false);
              }}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Archive customer</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                  Archive {fullCustomer?.businessName || customer?.businessName || "this customer"}?
                  This removes the customer from live customer workflows while preserving historical records.
                </DialogContentText>
                <TextField
                  label="Archive note (optional)"
                  value={archiveNote}
                  onChange={(event) => setArchiveNote(event.target.value)}
                  placeholder="Add a reason or internal note..."
                  fullWidth
                  multiline
                  minRows={3}
                  autoFocus
                  disabled={archivingCustomer}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setArchiveDialogOpen(false)}
                  disabled={archivingCustomer}
                >
                  Cancel
                </Button>
                <Button
                  onClick={archiveCustomer}
                  variant="contained"
                  disabled={archivingCustomer}
                >
                  {archivingCustomer ? "Archiving..." : "Archive customer"}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={mergeDialogOpen} onClose={() => setMergeDialogOpen(false)} fullWidth maxWidth="lg">
              <DialogTitle sx={{ pb: 1 }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: "action.hover", display: "grid", placeItems: "center" }}><PeopleIcon color="primary" /></Box>
                  <Box><Typography variant="h6" fontWeight={800}>Merge customers</Typography>
                    <Typography variant="body2" color="text.secondary">Compare both records, review additions, then confirm a safe merge.</Typography></Box>
                </Stack>
              </DialogTitle>
              <DialogContent>
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
                  <Chip size="small" label="1 · Choose customer to keep" color="primary" variant="outlined" />
                  <Chip size="small" label="2 · Compare details" color={mergePreview ? "primary" : "default"} variant="outlined" />
                  <Chip size="small" label="3 · Confirm" variant="outlined" />
                </Stack>
                <Alert severity="info" sx={{ mb: 2 }}>Preview first—nothing is changed until you confirm. Existing customer information is preserved; only missing details are added. Customers with unresolved links cannot be merged.</Alert>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Customer to merge: <strong>{fullCustomer?.businessName || customer?.businessName}</strong>
                  {" "} (#{customer?.id}). Search for the existing customer you want to merge this record into.
                </Typography>
                <Autocomplete
                  options={mergeCandidates}
                  filterOptions={(options) => options}
                  value={mergeSelectedCustomer}
                  inputValue={mergeSearch}
                  loading={mergeSearchLoading}
                  onInputChange={(_event, value, reason) => {
                    if (reason !== "input" && reason !== "clear") return;
                    setMergeSearch(value);
                    if (mergeSelectedCustomer) {
                      setMergeSelectedCustomer(null);
                      setMergeTargetId("");
                      setMergePreview(null);
                    }
                    setMergePreviewError("");
                  }}
                  onChange={(_event, option) => {
                    setMergeSelectedCustomer(option);
                    setMergeTargetId(option ? String(option.id) : "");
                    setMergeSearch(option ? mergeCustomerLabel(option) : "");
                    setMergePreview(null);
                    setMergePreviewError("");
                  }}
                  getOptionLabel={mergeCustomerLabel}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={(params) => <TextField {...params} label="Merge into customer" placeholder="Search all customers by name, email, or ID" helperText="The selected customer keeps its record and ID. The current customer is archived only after you confirm an eligible merge." />}
                  sx={{ mb: 2 }}
                />
                {mergePreviewError && <Alert severity="warning" sx={{ mb: 2 }}>{mergePreviewError}</Alert>}
                {mergePreview && <Grid container spacing={2} sx={{ mb: 2 }}>
                  {[
                    { title: "FROM · Duplicate to archive", record: mergePreview.source, accent: "warning.main" },
                    { title: "INTO · Customer to keep", record: mergePreview.survivor, accent: "success.main" }
                  ].map(({ title, record, accent }) => <Grid item xs={12} md={6} key={title}>
                    <Paper variant="outlined" sx={{ p: 2, height: "100%", borderTop: "3px solid", borderTopColor: accent, borderRadius: 2 }}>
                      <Typography variant="overline" color="text.secondary">{title}</Typography>
                      <Typography variant="h6" fontWeight={700}>{record?.businessName || "Unnamed customer"}</Typography>
                      <Typography variant="caption" color="text.secondary">Customer #{record?.id}</Typography>
                      <Divider sx={{ my: 1.5 }} />
                      <Typography variant="body2"><strong>Email:</strong> {record?.emailAddress || "Not provided"}</Typography>
                      <Typography variant="body2"><strong>Phone:</strong> {record?.phoneNumber || "Not provided"}</Typography>
                      <Typography variant="body2"><strong>Assigned users:</strong> {record?.assignedUsers ?? 0}</Typography>
                      <Typography variant="subtitle2" sx={{ mt: 2 }}>Contacts ({record?.contacts?.length || 0})</Typography>
                      {(record?.contacts || []).slice(0, 8).map((contact, i) =>
                        <Typography variant="body2" key={i}>{[contact.firstName, contact.lastName].filter(Boolean).join(" ") || "Contact"} · {contact.email || contact.emailAddress || "No email"}</Typography>)}
                      {(record?.contacts?.length || 0) > 8 && <Typography variant="caption">+{record.contacts.length - 8} more</Typography>}
                      <Typography variant="subtitle2" sx={{ mt: 2 }}>Addresses ({record?.addresses?.length || 0})</Typography>
                      {(record?.addresses || []).slice(0, 8).map((address, i) =>
                        <Typography variant="body2" key={i}>{[address.addressName, address.street || address.streetAddress, address.city].filter(Boolean).join(" · ") || "Address details incomplete"}</Typography>)}
                      {(record?.addresses?.length || 0) > 8 && <Typography variant="caption">+{record.addresses.length - 8} more</Typography>}
                    </Paper>
                  </Grid>)}
                  <Grid item xs={12}><Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="subtitle1" fontWeight={700}>What this merge will do</Typography>
                    <Typography variant="body2">Add {mergePreview.additions?.contacts || 0} contacts and {mergePreview.additions?.addresses || 0} addresses; fill {(mergePreview.additions?.fields || []).length} empty fields. Existing survivor details stay unchanged.</Typography>
                    <Typography variant="body2">Archive duplicate customer #{mergePreview.source?.id} from active customer lists. The survivor keeps ID #{mergePreview.survivor?.id}.</Typography>
                    {!mergePreview.canCommit && <Typography variant="body2" color="warning.main">Confirmation blocked until linked records and conflicts are resolved.</Typography>}
                  </Paper></Grid>
                </Grid>}
                {mergePreview && <Alert severity="info" sx={{ mb: 2 }}>
                  <strong>{mergePreview.survivor?.businessName}</strong> is the customer record that will be kept.
                  <Box sx={{ mt: 1 }}>New contacts: {mergePreview.additions?.contacts || 0} · Enriched contacts: {mergePreview.additions?.enrichedContacts || 0} · New addresses: {mergePreview.additions?.addresses || 0}</Box>
                  <Box>New blank fields: {(mergePreview.additions?.fields || []).join(", ") || "None"}</Box>
                  {Object.entries(mergePreview.conflicts || {}).filter(([, flag]) => flag).map(([key]) => (
                    <Box key={key} sx={{ color: "warning.main" }}>Requires review: {key}</Box>
                  ))}
                </Alert>}
                {mergePreview && <Alert severity={mergePreview.canCommit ? "success" : "warning"}>
                  {mergePreview.message}
                  {(mergePreview.linkedRecords || []).map((link, index) => (
                    <Box key={index}>{link.table}: {link.count} linked records (merge blocked)</Box>
                  ))}
                  {mergePreview.needsReview?.contacts?.length > 0 && <Box>Unresolved contacts: {mergePreview.needsReview.contacts.length}</Box>}
                  {mergePreview.needsReview?.addresses?.length > 0 && <Box>Unresolved addresses: {mergePreview.needsReview.addresses.length}</Box>}
                </Alert>}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setMergeDialogOpen(false)}>Cancel</Button>
                {mergePreview?.canCommit && <Button color="warning" variant="contained" disabled={mergeSaving}
                  onClick={async () => {
                    if (!window.confirm(`Merge customer #${customer.id} into #${mergeTargetId} and archive the duplicate? This cannot be automatically undone.`)) return;
                    setMergeSaving(true);
                    setMergePreviewError("");
                    try {
                      await axios.post(
                        `${process.env.REACT_APP_NODEJS_SERVER_URL}/api/instances/${instanceUniqueId}/tools/customer-merge/commit`,
                        { sourceId: customer.id, survivorId: Number(mergeTargetId), fingerprint: mergePreview.fingerprint },
                        { headers: { accessToken: localStorage.getItem("accessToken") } }
                      );
                      setMergeDialogOpen(false);
                      window.location.reload();
                    } catch (error) {
                      setMergePreview(null);
                      setMergePreviewError(error?.response?.data?.error || "Merge failed; review both customers again.");
                    } finally { setMergeSaving(false); }
                  }}> {mergeSaving ? "Merging..." : "Confirm merge and archive duplicate"} </Button>}

                <Button
                  variant="contained"
                  disabled={!mergeTargetId || mergePreviewLoading || mergeSaving}
                  onClick={async () => {
                    setMergePreview(null);
                    if (String(mergeTargetId) === String(customer?.id)) {
                      setMergePreviewError("Choose a different customer to merge into."); return;
                    }
                    setMergePreviewLoading(true);
                    setMergePreviewError("");
                    try {
                      const response = await axios.post(
                        `${process.env.REACT_APP_NODEJS_SERVER_URL}/api/instances/${instanceUniqueId}/tools/customer-merge/preview`,
                        { instanceUniqueId, sourceId: customer.id, survivorId: Number(mergeTargetId) },
                        { headers: { accessToken: localStorage.getItem("accessToken") } }
                      );
                      setMergePreview(response.data);
                    } catch (error) {
                      setMergePreviewError(error?.response?.data?.error || "Unable to preview customer merge.");
                    } finally { setMergePreviewLoading(false); }
                  }}
                >{mergePreviewLoading ? "Checking..." : "Review merge"}</Button>
              </DialogActions>
            </Dialog>

            {/* Reusable Actions Bar */}
            <PopupActionsBar
              loading={false}
              actions={[
                // Only on “My Leads” or “All Accounts, and only for users allowed to convert:
                ...(!isArchivedCustomer &&
                (viewScreen === "My Leads" ||
                  viewScreen === "All Accounts") &&
                canConvertLeadToCustomer
                  ? [
                      {
                        label:
                          customer.status === "in-review"
                            ? "Customer status in review"
                            : "Convert to Customer",
                        onClick: () => {
                          // If it’s in review, do nothing:
                          if (customer.status === "in-review") return;

                          // Otherwise, proceed with conversion:
                          if (
                            window.confirm(
                              "Really convert this Lead to a Customer?",
                            )
                          ) {
                            requestCustomerConversion(customer.id)
                              .then(() =>
                                toast.success(
                                  "Conversion requested — email will be sent",
                                ),
                              )
                              .catch((error) => {
                                console.error(error);
                                toast.error(
                                  getApiErrorMessage(
                                    error,
                                    "Failed to request customer conversion.",
                                  ),
                                );
                              });
                          }
                        },
                        disabled: customer.status === "in-review",
                      },
                    ]
                  : []),

                ...(canArchiveCustomers && !isArchivedCustomer
                  ? [{ label: "Merge", onClick: openMergeDialog }]
                  : []),

                ...(canArchiveCustomers
                  ? [
                      isArchivedCustomer
                        ? {
                            label: "Archived",
                            onClick: () => {},
                            disabled: true,
                          }
                        : {
                            label: archivingCustomer ? "Archiving..." : "Archive customer",
                            onClick: openArchiveDialog,
                            disabled: archivingCustomer,
                          },
                    ]
                  : []),

                // Always show “Email client contact”:
                {
                  label: "Email client contact",
                  onClick: () => setShowEmailDialog(true),
                },
              ]}
            />

            {/* Tabs Header */}
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab
                label={isLead ? "Edit Lead" : "Edit Customer"}
                value="edit"
              />

              <Tab label="Files" value="files" />
              <Tab label="Addresses" value="addresses" />
              <Tab
                label={isLead ? "Quote History" : "Project History"}
                value="orders"
              />
              <Tab label="Contacts" value="contacts" />
              <Tab label="Customer Page" value="customer-page" />
              <Tab label="Shipping Accounts" value="shipping-accounts" />
              {canManageQboConnections && (
                <Tab
                  label="QuickBooks Connection"
                  value="quickbooks-connection"
                />
              )}
              {canEditAssignment && (
                <Tab label="Assigned Users" value="assigned" />
              )}
              <Tab label="History Log" value="history" />
            </Tabs>

            {/* Overview / Edit Customer (Tab 0) */}
            <TabPanel value={activeTab} index="edit">
              <Formik
                initialValues={overviewInitialValues}
                enableReinitialize
                validationSchema={customerOverviewValidationSchema}
                onSubmit={handleOverviewSubmit}
              >
                {({ isSubmitting, errors, submitCount }) => {
                  const validationErrors =
                    submitCount > 0
                      ? Object.entries(errors).map(([field, message]) => {
                          const label = overviewFieldLabels[field] || field;
                          const text = Array.isArray(message)
                            ? message.join(", ")
                            : String(message);
                          return text
                            .toLowerCase()
                            .includes(label.toLowerCase())
                            ? text
                            : `${label}: ${text}`;
                        })
                      : [];
                  const saveErrors = [
                    ...new Set([
                      ...validationErrors,
                      ...overviewSubmitErrors,
                    ]),
                  ];

                  return (
                  <Form className="create-order-dialog-form">
                    {saveErrors.length > 0 && (
                      <Alert severity="error" sx={{ mb: 2 }}>
                        <Typography
                          component="div"
                          sx={{ fontWeight: 700, mb: 0.5 }}
                        >
                          Unable to save {isLead ? "lead" : "customer"}
                        </Typography>
                        {saveErrors.length === 1 ? (
                          saveErrors[0]
                        ) : (
                          <Box component="ul" sx={{ my: 0, pl: 2.5 }}>
                            {saveErrors.map((message) => (
                              <li key={message}>{message}</li>
                            ))}
                          </Box>
                        )}
                      </Alert>
                    )}
                    <Box mb={2}>
                      <Field
                        as={TextField}
                        label={isLead ? "Lead Name" : "Customer Name"}
                        disabled={!canEditCore}
                        name="businessName"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="businessName" />}
                      />
                    </Box>
                    <Box mb={2}>
                      <Field
                        as={TextField}
                        label="Email"
                        disabled={!canEditContact}
                        name="emailAddress"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="emailAddress" />}
                      />
                    </Box>
                    <Box mb={2}>
                      <Field
                        as={TextField}
                        label="Phone"
                        disabled={!canEditContact}
                        name="phoneNumber"
                        fullWidth
                        className="create-order-input"
                        helperText={<ErrorMessage name="phoneNumber" />}
                      />
                    </Box>

                    <Box mb={2}>
                      <Field
                        as={TextField}
                        select
                        label="Default Tax"
                        name="defaultTax"
                        fullWidth
                        disabled={!canEditCore}
                        helperText={
                          <Box component="span">
                            <ErrorMessage name="defaultTax" />
                            {resolveTaxSelectValue(fullCustomer?.defaultTax) === "" && (
                              <Box component="span" sx={{ display: "block", mt: 0.5 }}>
                                {instanceTermsDefaultLoading
                                  ? "No customer-specific tax saved · checking Company Defaults…"
                                  : instanceTermsDefaultError
                                    ? "Unable to verify Company Defaults tax"
                                    : resolveTaxSelectValue(instanceDefaultTaxId) !== ""
                                      ? "Using company default tax. Choose a different tax to customize this customer."
                                      : "No customer-specific tax or Company Defaults tax configured"}
                              </Box>
                            )}
                          </Box>
                        }
                      >
                        <MenuItem value="">No customer-specific tax (use Company Defaults)</MenuItem>
                        {taxOptions.map((tax) => (
                          <MenuItem key={tax.id} value={tax.id}>
                            {tax.name} ({(tax.value * 100).toFixed(0)}%)
                          </MenuItem>
                        ))}
                      </Field>
                    </Box>

                    <Box mb={2}>
                      <Field
                        as={TextField}
                        select
                        label="Payment Terms"
                        name="terms"
                        fullWidth
                        disabled={!canEditCore}
                        helperText={
                          <Box component="span">
                            <ErrorMessage name="terms" />
                            {storedCustomerTermId === "" && (
                              <Box component="span" sx={{ display: "block", mt: 0.5 }}>
                                {instanceTermsDefaultLoading
                                  ? "No customer-specific term saved · checking Company Defaults…"
                                  : instanceTermsDefaultError
                                    ? "No customer-specific term saved · unable to verify inherited Company Defaults"
                                    : effectiveDefaultTermLabel
                                      ? `Using company default: ${effectiveDefaultTermLabel}. Choose a different term to customize this customer.`
                                      : "No customer-specific term saved · no Company Defaults payment term configured"}
                              </Box>
                            )}
                            {storedCustomerTermId !== "" && (
                              <Box component="span" sx={{ display: "block", mt: 0.5 }}>
                                Customer-specific payment term saved (Terms ID #{storedCustomerTermId})
                              </Box>
                            )}
                          </Box>
                        }
                      >
                        <MenuItem value="">No customer-specific terms (use Company Defaults)</MenuItem>
                        {termsOptions.map((t) => (
                          <MenuItem key={t.id} value={t.id}>
                            {t.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </Box>

                    {/* ► Default Currency */}
                    <Box mb={2}>
                      <Field
                        as={TextField}
                        select
                        label="Default Currency"
                        name="defaultCurrency"
                        fullWidth
                        disabled={!canEditCore}
                        className="create-order-input"
                        helperText={<ErrorMessage name="defaultCurrency" />}
                      >
                        {currencyOptions.map((opt) => (
                          <MenuItem key={opt.id} value={opt.id}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Field>
                    </Box>

                    {/* ► Industry (multi-select) */}
                    <Box mb={2}>
                      <FormControl
                        fullWidth
                        disabled={!canEditCore}
                        className="create-order-input"
                      >
                        <InputLabel id="industry-label">Industry</InputLabel>

                        <Field name="industry">
                          {({
                            field /* { name, value, onChange, onBlur } */,
                          }) => (
                            <Select
                              {...field}
                              multiple
                              labelId="industry-label"
                              input={<OutlinedInput label="Industry" />}
                              renderValue={(selected) =>
                                (selected || []).join(", ")
                              }
                            >
                              {getIndustryOptions(field.value).map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                  {/* now we actually tell the checkbox if it’s in the array */}
                                  <Checkbox
                                    checked={(field.value || []).includes(opt.value)}
                                  />
                                  <ListItemText primary={opt.label} />
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        </Field>

                        <FormHelperText>
                          <ErrorMessage name="industry" />
                        </FormHelperText>
                      </FormControl>
                    </Box>

                    {canEditContact ? (
                      <>
                        <DialogActions className="customer-detail-dialog-actions">
                        <Button
                          type="submit"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? <ButtonLoader /> : canEditCore ? "Save Overview" : "Save Contact Details"}
                        </Button>
                          <Button onClick={onClose} color="secondary">
                            Cancel
                          </Button>
                        </DialogActions>

                        {canEditCore && <Box mt={2}>
                          <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography sx={{ fontWeight: 700 }}>
                                Raw JSON data
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <pre
                                style={{
                                  fontSize: 11,
                                  background: "#111",
                                  color: "#0f0",
                                  padding: 8,
                                  borderRadius: 8,
                                  overflow: "auto",
                                  maxHeight: 320,
                                  margin: 0,
                                }}
                              >
                                {JSON.stringify(fullCustomer, null, 2)}
                              </pre>
                            </AccordionDetails>
                          </Accordion>
                        </Box>}
                      </>
                    ) : (
                      ""
                    )}
                  </Form>
                  );
                }}
              </Formik>
            </TabPanel>

            <TabPanel value={activeTab} index="files">
              <OrderFiles customerId={fullCustomer?.id || customer?.id} />
            </TabPanel>

            {/* Addresses (Tab 1) */}
            <TabPanel value={activeTab} index="addresses">
              <Formik
                initialValues={addressesInitialValues}
                enableReinitialize
                validationSchema={customerAddressValidationSchema}
                onSubmit={handleAddressesSubmit}
              >
                {({ isSubmitting, values, errors, touched, setFieldValue }) => (
                  <Form className="create-order-dialog-form">
                    <FieldArray name="addresses">
                      {({ remove, push }) => (
                        <CustomerRecordBrowser items={values.addresses} fields={CUSTOMER_ADDRESS_SEARCH_FIELDS} label="Addresses">
                          {(visibleIndices) => (
                          <div className="address-array-container">
                          {visibleIndices.map((index) => ({ address: values.addresses[index], index })).map(({ address, index }) => (
                            <Paper
                              key={index}
                              elevation={0}
                              sx={{
                                mb: 3,
                                overflow: "hidden",
                                border: "1px solid #dbe4ef",
                                borderRadius: 3,
                                background:
                                  "linear-gradient(180deg, rgba(248,250,252,0.95) 0%, #ffffff 28%)",
                                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
                              }}
                            >
                              <Box
                                sx={{
                                  px: { xs: 2, md: 2.5 },
                                  py: 2,
                                  borderBottom: "1px solid",
                                  borderColor: "rgba(148, 163, 184, 0.18)",
                                  background:
                                    "linear-gradient(135deg, rgba(226,232,240,0.42) 0%, rgba(255,255,255,0.98) 80%)",
                                }}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems={{ xs: "flex-start", sm: "center" }}
                                  gap={2}
                                  flexWrap="wrap"
                                >
                                  <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
                                    <Avatar
                                      variant="rounded"
                                      sx={{
                                        width: 52,
                                        height: 52,
                                        borderRadius: "50%",
                                        bgcolor: "rgba(199, 9, 9, 0.10)",
                                        color: "primary.main",
                                        border: "1px solid rgba(199, 9, 9, 0.12)",
                                      }}
                                    >
                                      <LocationOnOutlinedIcon sx={{ fontSize: 24 }} />
                                    </Avatar>
                                    <Box minWidth={0}>
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontWeight: 700,
                                          color: "text.primary",
                                          lineHeight: 1.2,
                                        }}
                                      >
                                        {isAddressEmpty(address)
                                          ? "New Address"
                                          : getAddressDisplayName(address, index)}
                                      </Typography>
                                      <Stack spacing={0.35} sx={{ mt: 0.6 }}>
                                        {getAddressSummaryLines(address).map((line, lineIndex) => (
                                          <Typography
                                            key={`${index}-${lineIndex}`}
                                            variant="caption"
                                            sx={{ color: "text.secondary", fontSize: "0.76rem", lineHeight: 1.35 }}
                                          >
                                            {line}
                                          </Typography>
                                        ))}
                                      </Stack>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Box sx={{ px: { xs: 2, md: 2.5 }, py: 2.25 }}>
                              {/* Hidden field to preserve address ID */}
                              <Field
                                type="hidden"
                                name={`addresses.${index}.id`}
                              />
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <SmartAddressAutocomplete
                                    googlePlacesConfig={googlePlacesConfig}
                                    country={values.addresses[index]?.country}
                                    onAddressSelected={(selectedAddress) => {
                                      if (selectedAddress?.street) {
                                        setFieldValue(`addresses.${index}.street`, selectedAddress.street);
                                      }
                                      if (selectedAddress?.city) {
                                        setFieldValue(`addresses.${index}.city`, selectedAddress.city);
                                      }
                                      if (selectedAddress?.state) {
                                        setFieldValue(`addresses.${index}.state`, selectedAddress.state);
                                      }
                                      if (selectedAddress?.postal) {
                                        setFieldValue(`addresses.${index}.postal`, selectedAddress.postal);
                                      }
                                      if (selectedAddress?.country) {
                                        setFieldValue(`addresses.${index}.country`, selectedAddress.country);
                                      }
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Address Name"
                                    name={`addresses.${index}.addressName`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    placeholder="e.g., Main Office, Receiving Dock"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.addressName`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.addressName`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.addressName`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.addressName`,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    select
                                    label="Address Type"
                                    fullWidth
                                    size="small"
                                    className="create-order-input"
                                    sx={{ "& .MuiOutlinedInput-root": { height: 50 } }}
                                    value={values.addresses[index]?.addressType || "both"}
                                    onChange={(event) =>
                                      setFieldValue(`addresses.${index}.addressType`, event.target.value)
                                    }
                                    InputProps={{ sx: { bgcolor: "#EEE" } }}
                                    error={Boolean(getIn(touched, `addresses.${index}.addressType`) && getIn(errors, `addresses.${index}.addressType`))}
                                    helperText={getIn(touched, `addresses.${index}.addressType`) && getIn(errors, `addresses.${index}.addressType`)}
                                  >
                                    {CUSTOMER_ADDRESS_TYPE_OPTIONS.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                    ))}
                                  </TextField>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Street"
                                    name={`addresses.${index}.street`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.street`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.street`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.street`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.street`,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Suite / Unit / Floor (optional)"
                                    name={`addresses.${index}.suiteApt`}
                                    fullWidth
                                    size="small"
                                    className="create-order-input"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="City"
                                    name={`addresses.${index}.city`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.city`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.city`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.city`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.city`,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label={getCustomerAddressRegionLabel(
                                      values.addresses[index]?.country,
                                    )}
                                    name={`addresses.${index}.state`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.state`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.state`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.state`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.state`,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Postal Code"
                                    name={`addresses.${index}.postal`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.postal`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.postal`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.postal`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.postal`,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    select
                                    label="Country"
                                    name={`addresses.${index}.country`}
                                    fullWidth
                                    required
                                    size="small"
                                    className="create-order-input"
                                    sx={{ "& .MuiOutlinedInput-root": { height: 50 } }}
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#EEE",
                                      },
                                    }}
                                    error={Boolean(
                                      getIn(
                                        touched,
                                        `addresses.${index}.country`,
                                      ) &&
                                        getIn(
                                          errors,
                                          `addresses.${index}.country`,
                                        ),
                                    )}
                                    helperText={
                                      getIn(
                                        touched,
                                        `addresses.${index}.country`,
                                      ) &&
                                      getIn(
                                        errors,
                                        `addresses.${index}.country`,
                                      )
                                    }
                                  >
                                    {CUSTOMER_ADDRESS_COUNTRY_OPTIONS.map((country) => (
                                      <MenuItem key={country} value={country}>
                                        {country}
                                      </MenuItem>
                                    ))}
                                  </Field>
                                </Grid>
                              </Grid>
                              <Box
                                mt={2}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                gap={1}
                                flexWrap="wrap"
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ color: "text.secondary", fontSize: "0.76rem" }}
                                >
                                  Keep location details current for billing, shipping, and order workflows.
                                </Typography>
                                <Box display="flex" justifyContent="flex-end" gap={1}>
                                {values.addresses.length > 1 && (
                                  <Button
                                    variant="text"
                                    color="error"
                                    onClick={() => remove(index)}
                                    startIcon={<DeleteOutlineOutlinedIcon />}
                                    sx={{
                                      textTransform: "none",
                                      fontWeight: 600,
                                      px: 1,
                                    }}
                                  >
                                    Remove
                                  </Button>
                                )}
                                {index === values.addresses.length - 1 && (
                                  <Button
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    onClick={() =>
                                      push({
                                        ...blankAddress,
                                        street: "",
                                        city: "",
                                        state: "",
                                        postal: "",
                                      })
                                    }
                                    className="MuiButton-textSecondary"
                                    sx={{
                                      textTransform: "none",
                                      fontWeight: 600,
                                      borderRadius: 2,
                                    }}
                                  >
                                    Add More
                                  </Button>
                                )}
                                </Box>
                              </Box>
                              </Box>
                            </Paper>
                          ))}
                        </div>
                          )}
                        </CustomerRecordBrowser>
                      )}
                    </FieldArray>
                    <CustomerStickyActions isSubmitting={isSubmitting} onClose={onClose} label="Addresses" recordCount={values.addresses.length} />
                  </Form>
                )}
              </Formik>
            </TabPanel>

            {/* Projects (Tab 2 - Read-Only) */}
            <TabPanel value={activeTab} index="orders">
              <TableContainer
                sx={{
                  maxHeight: 440,
                  overflow: "auto",
                  border: `1px solid ${historyTableColors.border}`,
                  borderRadius: 2,
                  "&::-webkit-scrollbar": { width: 6, height: 6 },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "var(--ec-color-border-strong)",
                    borderRadius: 99,
                  },
                }}
              >
                <Table stickyHeader size="small" sx={{ minWidth: 760 }}>
                  <TableHead>
                    <TableRow>
                      {["Project #", "Project Name", "SO Status", "PO Status", "Action"].map((label) => (
                        <TableCell
                          key={label}
                          sx={{
                            px: 2,
                            py: 1.25,
                            backgroundColor: "#f8fafc !important",
                            color: "var(--ec-table-head-text-muted)",
                            fontWeight: 700,
                            fontSize: "0.72rem",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            borderBottom: "none",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "& .MuiTableCell-root": {
                        borderBottom: `1px solid ${historyTableColors.border}`,
                      },
                      "& .MuiTableRow-root:last-child .MuiTableCell-root": {
                        borderBottom: "none",
                      },
                    }}
                  >
                    {workflowSettingsLoading &&
                      [...Array(3)].map((_, index) => (
                        <TableRow key={index}>
                          {["project", "name", "so", "po", "action"].map((cell) => (
                            <TableCell key={cell} sx={{ px: 2, py: historyDensity.py }}>
                              <Skeleton variant="rectangular" height={20} sx={{ borderRadius: 1 }} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}

                    {!workflowSettingsLoading && orders.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={5} align="center" sx={{ py: 8 }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <FolderOffIcon
                              sx={{ fontSize: 36, color: "var(--ec-color-text-muted)" }}
                            />
                            <Typography variant="h6" fontWeight={600} color="text.secondary">
                              No projects found
                            </Typography>
                            <Typography variant="body2" color="text.disabled">
                              No projects or quotes have been linked to this customer yet.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}

                    {!workflowSettingsLoading &&
                      projectHistoryRows.map((order, index) => {
                        const soRaw = canonicalizeSoDisplay(order.OrderStatus?.SO || "");
                        const poRaw = String(order.OrderStatus?.PO || "").trim();

                        return (
                          <TableRow
                            key={order.OrderId || order.id || index}
                            hover
                            onClick={() =>
                              history.push(
                                `/instance/${instanceUniqueId}/sales/orders/${order.OrderId}/overview`,
                              )
                            }
                            sx={{
                              cursor: "pointer",
                              backgroundColor: historyTableColors.paperBg,
                              transition: "background-color 0.1s",
                              "&:hover": { backgroundColor: historyTableColors.subtleBg },
                            }}
                          >
                            <TableCell sx={{ px: 2, py: historyDensity.py }}>
                              <Typography
                                variant="body2"
                                fontWeight={700}
                                sx={{
                                  fontFamily: "monospace",
                                  color: "primary.main",
                                  fontSize: "0.82rem",
                                }}
                              >
                                #{order.OrderId}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ px: 2, py: historyDensity.py, color: historyTableColors.textPri }}>
                              <Tooltip title={order.ProjectName || "Untitled"}>
                                <Typography
                                  variant="body2"
                                  fontWeight={600}
                                  sx={{
                                    maxWidth: 260,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {order.ProjectName || "Untitled"}
                                </Typography>
                              </Tooltip>
                            </TableCell>
                            <TableCell sx={{ px: 2, py: historyDensity.py }}>
                              {soRaw ? (
                                <Tooltip title={getWorkflowTooltip("SO", soRaw) || getWorkflowLabel("SO", soRaw)}>
                                  <Box component="span">
                                    <UIStatusChip
                                      label={getWorkflowLabel("SO", soRaw)}
                                      tone={getSOStatusTone(soRaw)}
                                    />
                                  </Box>
                                </Tooltip>
                              ) : (
                                <Typography variant="caption" color="text.disabled">—</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ px: 2, py: historyDensity.py }}>
                              {poRaw ? (
                                <Tooltip title={getWorkflowTooltip("PO", poRaw) || getWorkflowLabel("PO", poRaw)}>
                                  <Box component="span">
                                    <UIStatusChip
                                      label={getWorkflowLabel("PO", poRaw)}
                                      tone={getPOStatusTone(poRaw)}
                                    />
                                  </Box>
                                </Tooltip>
                              ) : (
                                <Typography variant="caption" color="text.disabled">—</Typography>
                              )}
                            </TableCell>
                            <TableCell
                              sx={{ px: 2, py: historyDensity.py }}
                              onClick={(event) => event.stopPropagation()}
                            >
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<VisibilityIcon sx={{ fontSize: "0.85rem !important" }} />}
                                onClick={() =>
                                  history.push(
                                    `/instance/${instanceUniqueId}/sales/orders/${order.OrderId}/overview`,
                                  )
                                }
                                sx={{
                                  fontSize: "0.72rem",
                                  height: 28,
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  fontWeight: 600,
                                  minWidth: 76,
                                }}
                              >
                                View
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>

              {orders.length > HISTORY_ROWS_PER_PAGE && (
                <TablePagination
                  component="div"
                  count={orders.length}
                  page={historyPage}
                  onPageChange={(_, nextPage) => setHistoryPage(nextPage)}
                  rowsPerPage={HISTORY_ROWS_PER_PAGE}
                  rowsPerPageOptions={[HISTORY_ROWS_PER_PAGE]}
                  sx={{
                    border: 0,
                    "& .MuiTablePagination-toolbar": { minHeight: 48 },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                      fontSize: "0.8125rem",
                      color: "var(--ec-color-text-muted) !important",
                    },
                  }}
                />
              )}
            </TabPanel>

            {/* Contacts (Tab 3) */}
            <TabPanel value={activeTab} index="contacts">
              {canRepairCustomerContacts && !isArchivedCustomer && (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">Review duplicate contacts and their linked project or document references before making changes.</Typography>
                  <Button variant="outlined" onClick={() => setContactRepairOpen(true)}>Contact Repair</Button>
                </Box>
              )}
              <Formik
                initialValues={contactsInitialValues}
                enableReinitialize
                onSubmit={handleContactsSubmit}
              >
                {({ isSubmitting, values, setFieldValue }) => (
                  <Form className="create-order-dialog-form">
                    <FieldArray name="clientContacts">
                      {({ remove, push }) => (
                        <CustomerRecordBrowser items={values.clientContacts} fields={CUSTOMER_CONTACT_SEARCH_FIELDS} label="Contacts" isHidden={(contact) => Boolean(contact?.mergedIntoContactId)}>
                          {(visibleIndices) => (
                          <div className="client-contact-container">
                          {visibleIndices.map((index) => ({ contact: values.clientContacts[index], index })).map(({ contact, index }) => (
                            <Paper
                              key={contact.contactId || index}
                              elevation={0}
                              sx={{
                                mb: 3,
                                overflow: "hidden",
                                border: "1px solid #dbe4ef",
                                borderRadius: 3,
                                background:
                                  "linear-gradient(180deg, rgba(248,250,252,0.95) 0%, #ffffff 28%)",
                                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
                              }}
                            >
                              <Box
                                className="customer-contact-card-header"
                                sx={{
                                  px: { xs: 2, md: 2.5 },
                                  py: 2,
                                  borderBottom: "1px solid",
                                  borderColor: "rgba(148, 163, 184, 0.18)",
                                  background:
                                    "linear-gradient(135deg, rgba(226,232,240,0.42) 0%, rgba(255,255,255,0.98) 80%)",
                                }}
                              >
                                <Box
                                  className="customer-contact-card-header-inner"
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems={{ xs: "flex-start", sm: "center" }}
                                  gap={2}
                                  flexWrap="wrap"
                                >
                                  <Box
                                    className="customer-contact-card-identity"
                                    display="flex"
                                    alignItems="center"
                                    gap={1.5}
                                    minWidth={0}
                                  >
                                    <Avatar
                                      sx={{
                                        width: 52,
                                        height: 52,
                                        bgcolor: "rgba(199, 9, 9, 0.10)",
                                        color: "primary.main",
                                        fontWeight: 800,
                                        fontSize: "1rem",
                                        border: "1px solid rgba(199, 9, 9, 0.12)",
                                      }}
                                    >
                                      {getContactInitials(contact, index)}
                                    </Avatar>
                                    <Box minWidth={0}>
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontWeight: 700,
                                          color: "text.primary",
                                          lineHeight: 1.2,
                                        }}
                                      >
                                        {getContactDisplayName(contact, index)}
                                      </Typography>
                                      <Stack
                                        className="customer-contact-card-summary"
                                        direction="row"
                                        spacing={1.5}
                                        useFlexGap
                                        flexWrap="wrap"
                                        alignItems="center"
                                        sx={{ mt: 0.6 }}
                                      >
                                        <Box
                                          sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 0.6,
                                            color: "text.secondary",
                                          }}
                                        >
                                          <EmailOutlinedIcon sx={{ fontSize: 15 }} />
                                          <Typography variant="caption" sx={{ fontSize: "0.76rem" }}>
                                            {contact.email || "No email"}
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 0.6,
                                            color: "text.secondary",
                                          }}
                                        >
                                          <PhoneOutlinedIcon sx={{ fontSize: 15 }} />
                                          <Typography variant="caption" sx={{ fontSize: "0.76rem" }}>
                                            {contact.phone || "No phone"}
                                          </Typography>
                                        </Box>
                                        {contact.title ? (
                                          <Box
                                            sx={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: 0.6,
                                              color: "text.secondary",
                                            }}
                                          >
                                            <WorkOutlineOutlinedIcon sx={{ fontSize: 15 }} />
                                            <Typography variant="caption" sx={{ fontSize: "0.76rem" }}>
                                              {contact.title}
                                            </Typography>
                                          </Box>
                                        ) : null}
                                      </Stack>
                                    </Box>
                                  </Box>
                                  <Chip
                                    size="small"
                                    color={contact.isActive !== false ? "success" : "default"}
                                    label={contact.isActive !== false ? "Active" : "Inactive"}
                                    variant={contact.isActive !== false ? "filled" : "outlined"}
                                    sx={{ fontWeight: 700 }}
                                  />
                                </Box>
                              </Box>
                              <Box className="customer-contact-card-body" sx={{ px: { xs: 2, md: 2.5 }, py: 2.25 }}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="First Name"
                                    name={`clientContacts.${index}.firstName`}
                                    fullWidth
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Last Name"
                                    name={`clientContacts.${index}.lastName`}
                                    fullWidth
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Email"
                                    name={`clientContacts.${index}.email`}
                                    fullWidth
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Phone"
                                    name={`clientContacts.${index}.phone`}
                                    fullWidth
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Field
                                    as={TextField}
                                    label="Title"
                                    name={`clientContacts.${index}.title`}
                                    fullWidth
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    select
                                    label="Status"
                                    fullWidth
                                    size="small"
                                    className="create-order-input"
                                    value={contact.isActive !== false ? "active" : "inactive"}
                                    onChange={(event) =>
                                      setFieldValue(
                                        `clientContacts.${index}.isActive`,
                                        event.target.value === "active",
                                      )
                                    }
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#fff",
                                      },
                                    }}
                                  >
                                    <MenuItem value="active">Active</MenuItem>
                                    <MenuItem value="inactive">Inactive</MenuItem>
                                  </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                  <Field
                                    as={TextField}
                                    label="Note"
                                    name={`clientContacts.${index}.note`}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    className="create-order-input"
                                    size="small"
                                    InputProps={{
                                      sx: {
                                        bgcolor: "#EEE",
                                        alignItems: "flex-start",
                                      },
                                    }}
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        minHeight: 92,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Box
                                mt={2}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                gap={1}
                                flexWrap="wrap"
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ color: "text.secondary", fontSize: "0.76rem" }}
                                >
                                  Update the fields below to keep this contact current.
                                </Typography>
                                <Box display="flex" justifyContent="flex-end" gap={1}>
                                {values.clientContacts.filter((entry) => !entry?.mergedIntoContactId).length > 1 && (
                                  <Button
                                    variant="text"
                                    color="error"
                                    onClick={() => remove(index)}
                                    startIcon={<DeleteOutlineOutlinedIcon />}
                                    sx={{
                                      textTransform: "none",
                                      fontWeight: 600,
                                      px: 1,
                                    }}
                                  >
                                    Remove
                                  </Button>
                                )}

                                {values.clientContacts.slice(index + 1).every((entry) => Boolean(entry?.mergedIntoContactId)) && (
                                  <Button
                                    variant="outlined"
                                    className="MuiButton-textPrimary"
                                    startIcon={<AddIcon />}
                                    sx={{
                                      textTransform: "none",
                                      fontWeight: 600,
                                      borderRadius: 2,
                                    }}
                                    onClick={() =>
                                      push({
                                        firstName: "",
                                        lastName: "",
                                        email: "",
                                        phone: "",
                                        title: "",
                                        isActive: true,
                                        note: "",
                                      })
                                    }
                                  >
                                    Add More
                                  </Button>
                                )}
                                </Box>
                              </Box>
                              </Box>
                            </Paper>
                          ))}
                        </div>
                          )}
                        </CustomerRecordBrowser>
                      )}
                    </FieldArray>
                    <CustomerStickyActions isSubmitting={isSubmitting} onClose={onClose} label="Contacts" recordCount={values.clientContacts.filter((entry) => !entry?.mergedIntoContactId).length} />
                  </Form>
                )}
              </Formik>
            </TabPanel>

            <TabPanel value={activeTab} index="customer-page">
              <Stack spacing={3}>
                <Box>
                  <Typography variant="h6" fontWeight={700}>Customer Page</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Configure the customer-facing profile and invite specific CRM contacts to sign in.
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      select fullWidth label="Visibility"
                      value={portalSettings.publicVisibility}
                      onChange={(event) => {
                        if (event.target.value === "private") {
                          setPortalSettings((current) => ({ ...current, publicVisibility: event.target.value }));
                        }
                      }}
                    >
                      <MenuItem value="private">Private</MenuItem>
                      <MenuItem value="unlisted" disabled sx={{ pointerEvents: "auto" }}>
                        <Tooltip title="Unlisted mode is coming soon." placement="right">
                          <span style={{ display: "block", width: "100%" }}>Unlisted</span>
                        </Tooltip>
                      </MenuItem>
                      <MenuItem value="public" disabled sx={{ pointerEvents: "auto" }}>
                        <Tooltip title="Public mode is coming soon." placement="right">
                          <span style={{ display: "block", width: "100%" }}>Public</span>
                        </Tooltip>
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <TextField
                      fullWidth label="Public slug" placeholder="Generated from the business name when left blank"
                      value={portalSettings.publicSlug}
                      onChange={(event) => setPortalSettings((current) => ({ ...current, publicSlug: event.target.value.toLowerCase() }))}
                    />
                  </Grid>
                </Grid>
                {customerPageUrl ? (
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                    <TextField fullWidth label="Customer page URL" value={customerPageUrl} InputProps={{ readOnly: true }} />
                    <Button variant="outlined" onClick={() => { navigator.clipboard.writeText(customerPageUrl); toast.success("Customer page URL copied."); }}>Copy URL</Button>
                    <Button variant="outlined" onClick={() => window.open(customerPageUrl, "_blank", "noopener,noreferrer")}>Preview</Button>
                  </Stack>
                ) : null}
                <Box><Button variant="contained" disabled={savingPortalSettings} onClick={savePortalSettings}>{savingPortalSettings ? "Saving…" : "Save Customer Page"}</Button></Box>
                <Divider />
                <Typography variant="subtitle1" fontWeight={700}>Contact accounts</Typography>
                <Stack spacing={1.5}>
                  {(fullCustomer?.clientContacts || []).map((contact) => {
                    const contactId = contact.contactId || contact.id;
                    const status = contact.portalAccountStatus || (contact.userId ? "active" : "none");
                    return (
                      <Paper key={contactId} variant="outlined" sx={{ p: 2 }}>
                        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={1}>
                          <Box>
                            <Typography fontWeight={600}>{[contact.firstName, contact.lastName].filter(Boolean).join(" ") || contact.email}</Typography>
                            <Typography variant="body2" color="text.secondary">{contact.email}</Typography>
                          </Box>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Chip size="small" label={status === "invited" ? "Invited" : status === "active" ? "Active" : status === "invalid" ? "Invalid link" : "No account"} color={status === "active" ? "success" : status === "invited" ? "warning" : "default"} />
                            {!contact.userId ? <Button size="small" variant="outlined" disabled={Boolean(invitingContactId)} onClick={() => invitePortalContact(contact)}>{invitingContactId === contactId ? "Inviting…" : "Invite to Elite Core"}</Button> : null}
                          </Stack>
                        </Stack>
                      </Paper>
                    );
                  })}
                </Stack>
              </Stack>
            </TabPanel>

            <TabPanel value={activeTab} index="shipping-accounts">
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="h6">Customer Shipping Accounts</Typography>
                <Button
                  variant="contained"
                  onClick={() => setShippingAccountModalOpen(true)}
                >
                  Add Shipping Account
                </Button>
              </Box>
              {shippingAccountsLoading ? (
                <Typography>Loading shipping accounts...</Typography>
              ) : shippingAccounts.length === 0 ? (
                <Typography>
                  No shipping accounts found for this customer.
                </Typography>
              ) : (
                <Box sx={{ display: "grid", gap: 1 }}>
                  {shippingAccounts.map((account) => (
                    <Box
                      key={account.id}
                      sx={{
                        border: "1px solid #eee",
                        borderRadius: 2,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="subtitle1">
                          {account.accountName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {account.courier} • {account.accountNumber} •{" "}
                          {account.postalZipCode}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              <ThirdPartyShippingAccount
                open={shippingAccountModalOpen}
                onClose={() => setShippingAccountModalOpen(false)}
                customerId={fullCustomer?.id}
                instanceUniqueId={instanceUniqueId}
                onCreated={loadShippingAccounts}
              />
            </TabPanel>

            <TabPanel value={activeTab} index="quickbooks-connection">
              <Box sx={{ display: "grid", gap: 1.5 }}>
                <Typography variant="h6">
                  QuickBooks Customer Mapping
                </Typography>
                {!canManageQboConnections ? (
                  <Typography color="text.secondary">
                    Only administrators and finance reps can manage QuickBooks
                    mappings.
                  </Typography>
                ) : (
                  <>
                    <Typography variant="body2">
                      Status:{" "}
                      <strong>
                        {fullCustomer?.qbo_ref_id || fullCustomer?.qboRefId
                          ? "Linked"
                          : "Not linked"}
                      </strong>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      QBO Customer ID:{" "}
                      {fullCustomer?.qbo_ref_id ||
                        fullCustomer?.qboRefId ||
                        "—"}
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        onClick={() => setQboDialogOpen(true)}
                      >
                        Manage QuickBooks Link
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDisconnectQbo}
                        disabled={
                          disconnectingQbo ||
                          !(fullCustomer?.qbo_ref_id || fullCustomer?.qboRefId)
                        }
                      >
                        {disconnectingQbo ? "Disconnecting..." : "Disconnect"}
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            </TabPanel>

            {/* Assigned Users (Tab 4) */}
            <TabPanel value={activeTab} index="assigned">
              <OrderUserAssignment
                customerId={customer.id}
                initialAssignedUsers={customer.AssignedTo || []}
                onChangeAssignedUsers={(newUsers) => setAssignedUsers(newUsers)}
              />
              <Box mt={2}>
                <Button
                  onClick={handleAssignedUsersSubmit}
                  variant="contained"
                  color="primary"
                  disabled={savingAssignedUsers}
                >
                  {savingAssignedUsers ? (
                    <ButtonLoader />
                  ) : (
                    "Save Assigned Users"
                  )}
                </Button>
              </Box>
            </TabPanel>

            <TabPanel value={activeTab} index="history">
              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Search history"
                  placeholder="Search by message, action, user, role, order ID..."
                  value={historySearch}
                  onChange={(e) => setHistorySearch(e.target.value)}
                />
              </Box>

              {filteredHistoryRows.length > 0 ? (
                <>
                  {paginatedHistoryRows.map((note) => {
                    const actorName = String(note?.userName || "").trim();
                    const actorRole = formatRoleLabel(note?.userRole);
                    const actorId =
                      note?.userId != null ? `ID ${note.userId}` : "System";
                    const actorLine = actorName
                      ? `${actorName} · ${actorRole} (${actorId})`
                      : `${actorRole} (${actorId})`;
                    const canRenderHtml = maybeRenderHtml(note?.message);
                    const safeHtml = sanitizeNoteHtml(note?.message);
                    const avatarUrl = getNoteAvatarUrl(note?.userAvatar);

                    return (
                      <Paper
                        key={`${note.sequence}-${note.timestamp}`}
                        elevation={1}
                        sx={{
                          mb: 2,
                          p: 2,
                          display: "flex",
                          gap: 2,
                          borderRadius: 2,
                        }}
                      >
                        <Avatar
                          src={avatarUrl}
                          sx={{ bgcolor: "primary.main" }}
                        >
                          <HistoryIcon />
                        </Avatar>

                        <Box flexGrow={1}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 2,
                              mb: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                            >
                              #{note.sequence} ·{" "}
                              {new Date(note.timestamp).toLocaleString()}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                textTransform: "uppercase",
                                fontWeight: 700,
                                px: 1,
                                py: 0.25,
                                borderRadius: 1,
                                bgcolor: "grey.100",
                              }}
                            >
                              {formatActionLabel(note.action)}
                            </Typography>
                          </Box>

                          {canRenderHtml ? (
                            <Box
                              sx={{
                                mb: 1,
                                p: 1.5,
                                border: "1px solid",
                                borderColor: "grey.200",
                                borderRadius: 1,
                                backgroundColor: "grey.50",
                              }}
                              dangerouslySetInnerHTML={{ __html: safeHtml }}
                            />
                          ) : (
                            <Typography variant="body2" gutterBottom sx={{ whiteSpace: "pre-line" }}>
                              {note.message}
                            </Typography>
                          )}

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            By: {actorLine}
                          </Typography>
                          {note?.orderId ? (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: "block" }}
                            >
                              Linked Project: #{note.orderId}
                            </Typography>
                          ) : null}
                        </Box>
                      </Paper>
                    );
                  })}

                  <TablePagination
                    component="div"
                    count={filteredHistoryRows.length}
                    page={historyPage}
                    onPageChange={(_, nextPage) => setHistoryPage(nextPage)}
                    rowsPerPage={HISTORY_ROWS_PER_PAGE}
                    rowsPerPageOptions={[HISTORY_ROWS_PER_PAGE]}
                  />
                </>
              ) : (
                <Typography color="text.secondary">
                  {historySearch
                    ? "No history entries matched your search."
                    : `No history yet for this ${
                        viewScreen === "Leads" ? "lead" : "customer"
                      }.`}
                </Typography>
              )}
            </TabPanel>

            <CustomerContactRepairDialog
              open={contactRepairOpen}
              onClose={() => setContactRepairOpen(false)}
              customerId={customer.id}
              onRepaired={async () => {
                try {
                  const { data } = await axios.get(
                    `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}`,
                    { params: { accessContext: "customer-directory", instanceUniqueId }, headers: { accessToken: localStorage.getItem("accessToken") } },
                  );
                  const refreshed = normalizeCustomerForModal(data.customer || data);
                  setFullCustomer(refreshed);
                  onCustomerUpdated(refreshed);
                  toast.success("Contact repair saved; source IDs preserved as inactive aliases.");
                } catch (_error) {
                  toast.error("Contact repair saved. Reopen the customer to refresh contacts.");
                }
              }}
            />
            <QboCustomerLinkDialog
              open={qboDialogOpen}
              onClose={() => setQboDialogOpen(false)}
              instanceUniqueId={instanceUniqueId}
              customerId={fullCustomer?.id || customer?.id || null}
              customerName={
                fullCustomer?.businessName || customer?.businessName || ""
              }
              onLinked={async () => {
                setQboDialogOpen(false);
                try {
                  const {
                    data,
                  } = await axios.get(
                    `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customer.id}`,
                    {
                      params: { accessContext: "customer-directory", instanceUniqueId },
                      headers: {
                        accessToken: localStorage.getItem("accessToken"),
                      },
                    },
                  );
                  setFullCustomer(data.customer || data);
                } catch (err) {
                  console.error(
                    "Failed to refresh customer after QBO link update",
                    err,
                  );
                }
              }}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export { CustomerDetailModal };
